// import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
// import axios from "axios";
// import { jwtDecode } from "jwt-decode";
// import {
//   ChevronLeft,
//   ChevronRight,
//   Edit,
//   UserMinus,
//   Key,
//   X,
//   IndianRupee, 
//   TrendingUp,
//   Clock,
//   Search,
//   Users,
//   Mail,
//   Phone,
//   CheckCircle,
//   AlertCircle,
//   BarChart2,
//   UserPlus,
//   Briefcase,
//   Shield,
//   Globe,
//   Info,
//   Loader,
//   Save,
//   RefreshCw,
//   ChevronDown,
//   CreditCard,
//   History,
//   ArrowUpRight,
//   ArrowDownRight
// } from "lucide-react";
// import { API_URL } from "../../Constants";

// // --- UI Utility Functions ---

// // Account status badge
// const getStatusBadge = (status) => {
//   const isActive = status?.toLowerCase() === "active";
//   return (
//     <span
//       className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-[11px] font-bold tracking-wide ${isActive
//         ? "bg-emerald-50 text-emerald-700 border border-emerald-200"
//         : "bg-red-50 text-red-700 border border-red-200"
//         }`}
//     >
//       {isActive ? <CheckCircle size={10} /> : <AlertCircle size={10} />}
//       {status || "Unknown"}
//     </span>
//   );
// };

// // Account type badge
// const getTypeBadge = (type) => {
//   const styles = {
//     SUPER_ADMIN: "bg-purple-50 text-purple-700 border border-purple-200",
//     SUPER_SUPER_ADMIN: "bg-indigo-50 text-indigo-700 border border-indigo-200",
//     RESELLER: "bg-[#0C4550]/10 text-[#0C4550] border border-[#0C4550]/20", 
//     COMPANY: "bg-blue-50 text-blue-700 border border-blue-200",
//     ALL: "bg-gray-100 text-gray-700",
//   };
//   return (
//     <span
//       className={`inline-flex px-2.5 py-0.5 rounded-full text-[11px] font-bold tracking-wide w-fit ${styles[type] || "bg-gray-100 text-gray-700"
//         }`}
//     >
//       {type?.replace("_", " ") || "N/A"}
//     </span>
//   );
// };

// // --- Main Component ---

// const ViewAccount = () => {
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 4;
//   const [filterType, setFilterType] = useState("ALL");
//   const [userRole, setUserRole] = useState("");

//   // Balance States
//   const [balances, setBalances] = useState({});
//   const [balanceLoading, setBalanceLoading] = useState({});

//   // Modals States
//   const [editingUser, setEditingUser] = useState(null);
  
//   // State to hold the current form values
//   const [formData, setFormData] = useState({});
//   // State to hold the original values for comparison
//   const [originalData, setOriginalData] = useState({});
  
//   const [editLoading, setEditLoading] = useState(false);
//   const [suspendUser, setSuspendUser] = useState(null);
//   const [confirmCode, setConfirmCode] = useState("");
//   const [generatedCode, setGeneratedCode] = useState("");
  
//   // Explicit Password states
//   const [passwordUser, setPasswordUser] = useState(null);
//   const [passwordData, setPasswordData] = useState({ password: "", confirmPassword: "" });

//   // Transaction Modals States
//   const [smsPricingUser, setSmsPricingUser] = useState(null);
//   const [fundsUser, setFundsUser] = useState(null);
//   const [historyUser, setHistoryUser] = useState(null);

//   // SMS Pricing Modal States
//   const [smsPriceData, setSmsPriceData] = useState({ current: "", new: "" });
//   const [smsPriceLoading, setSmsPriceLoading] = useState(false);
//   const [smsUpdateLoading, setSmsUpdateLoading] = useState(false);

//   // Funds Modal States
//   const [fundsData, setFundsData] = useState({
//     amount: "",
//     action: "CREDIT" // CREDIT or DEBIT
//   });
//   const [fundsLoading, setFundsLoading] = useState(false);

//   // History Modal States
//   const [transactions, setTransactions] = useState([]);
//   const [historyLoading, setHistoryLoading] = useState(false);
//   const [historyFilter, setHistoryFilter] = useState("ALL");

//   // Active dropdown state
//   const [activeDropdown, setActiveDropdown] = useState(null);
  
//   // Refs for dropdown positioning
//   const buttonRefs = useRef({});

//   // Decode logged-in user role
//   useEffect(() => {
//     try {
//       const token = localStorage.getItem("token");
//       if (token) {
//         const decoded = jwtDecode(token);
//         setUserRole(decoded.accountType || decoded.role || "");
//       }
//     } catch (err) {
//       console.error("Error decoding token:", err);
//     }
//   }, [])

//   // Fetch users list
//   useEffect(() => {
//     const fetchUsers = async () => {
//       setLoading(true);
//       try {
//         const token = localStorage.getItem("token");
//         const response = await axios.get(`${API_URL}/api/v1/users/list`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
        
//         const usersList = response.data.data || response.data;
        
//         const mappedUsers = usersList.map(u => ({
//           ...u,
//           accountType: u.role || u.accountType,
//           accountStatus: u.active !== undefined ? (u.active ? "ACTIVE" : "INACTIVE") : u.accountStatus,
//           idValidFrom: u.validFrom || u.idValidFrom,
//           idValidTo: u.validTo || u.idValidTo
//         }));

//         setUsers(mappedUsers);
//       } catch (error) {
//         console.error("Error fetching users:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchUsers();
//   }, []);

//   // --- Utility Functions ---

//   const handleFetchBalance = async (userId) => {
//     if (balanceLoading[userId]) return;
//     setBalanceLoading((prev) => ({ ...prev, [userId]: true }));

//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.get(`${API_URL}/api/billing/child-balance/${userId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       const balanceValue = response.data?.balance !== undefined
//         ? response.data.balance
//         : response.data;

//       setBalances((prev) => ({ ...prev, [userId]: balanceValue }));
//     } catch (error) {
//       console.error(`Error fetching balance for user ${userId}:`, error);
//       setBalances((prev) => ({ ...prev, [userId]: "Error" }));
//     } finally {
//       setBalanceLoading((prev) => ({ ...prev, [userId]: false }));
//     }
//   };

//   // --- HANDLE EDIT (NEW GET API) ---
//   const handleEdit = useCallback(async (user) => {
//     setEditLoading(true);
//     setEditingUser(user); // Set early so modal opens showing loading spinner
//     try {
//       const token = localStorage.getItem("token");
      
//       // Fetch specific user details via NEW Hierarchy-Aware Endpoint
//       const response = await axios.get(`${API_URL}/api/v1/users/${user.id}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
      
//       // Unwrap standard ApiResponse
//       const userData = response.data.data || response.data;

//       // Date formatter for Instant / ISO strings / Arrays
//       const formatApiDate = (dateData) => {
//         if (!dateData) return "";
//         if (Array.isArray(dateData) && dateData.length >= 3) {
//             const year = dateData[0];
//             const month = String(dateData[1]).padStart(2, "0");
//             const day = String(dateData[2]).padStart(2, "0");
//             return `${year}-${month}-${day}`;
//         }
//         if (typeof dateData === 'string') {
//             return dateData.split('T')[0];
//         }
//         return "";
//       };

//       // Prepare initial object mapping for the form
//       const initialData = {
//         firstName: userData.firstName || "",
//         lastName: userData.lastName || "",
//         email: userData.email || "", // Kept for reference (uneditable typically)
//         phone: userData.phone || "",
        
//         companyName: userData.companyName || "",
//         companyType: userData.companyType || "", 
//         gstNumber: userData.gstNumber || "",
//         panNumber: userData.panNumber || "",
//         address: userData.address || "",
        
//         validFrom: formatApiDate(userData.validFrom), 
//         validTo: formatApiDate(userData.validTo),       
//         active: userData.active, // Boolean for Patch request

//         // Reference fields (read-only in form)
//         role: userData.role || "",
//       };

//       setFormData(initialData);
//       setOriginalData(initialData); // Exact copy to track isolated changes

//     } catch (error) {
//       console.error("Error fetching specific user details:", error);
//       alert("Failed to fetch user details. You may not have permission.");
//       setEditingUser(null);
//     } finally {
//       setEditLoading(false);
//     }
//   }, []);

//   const closeModal = () => {
//     setEditingUser(null);
//     setFormData({});
//     setOriginalData({});
//   };

//   // --- HANDLE UPDATE (PATCH API - SPECIFIC FIELDS ONLY) --- 
// const handleUpdate = async () => { 
//   try { 
//     const token = localStorage.getItem("token"); 
      
//     // Extract ONLY fields that have been modified compared to originalData 
//     const updates = {}; 
//     const allowedPatchFields = [ 
//       "firstName", "lastName", "phone", "address",  
//       "companyName", "companyType", "gstNumber", "panNumber",  
//       "validFrom", "validTo", "active" 
//     ]; 

//     allowedPatchFields.forEach((key) => { 
//       if (formData[key] !== originalData[key]) { 
//         if (key === 'validFrom' || key === 'validTo') {
//           // Handle Date Formatting for Java Instant
//           if (formData[key] === "") {
//             updates[key] = null; // Clear the date if empty
//           } else {
//             // Append midnight UTC time so the Java backend can parse it as an Instant
//             updates[key] = `${formData[key]}T00:00:00Z`; 
//           }
//         } else {
//           // Handle all other fields normally
//           updates[key] = formData[key];
//         }
//       } 
//     }); 

//     if (Object.keys(updates).length === 0) { 
//       alert("No changes detected."); 
//       return; 
//     } 

//     await axios.patch(`${API_URL}/api/v1/users/${editingUser.id}`, updates, { 
//       headers: { Authorization: `Bearer ${token}` }, 
//     }); 

//     alert("User updated successfully!"); 
//     closeModal(); 
//     window.location.reload(); 
//   } catch (error) { 
//     console.error("Error updating user:", error); 
//     alert("Failed to update user details."); 
//   } 
// };
//   // --- HANDLE PASSWORD CHANGE (EXPLICIT / SEPARATE API) ---
//   const handleChangePassword = (user) => {
//     setPasswordUser(user);
//     setPasswordData({ password: "", confirmPassword: "" });
//   };

//   const handlePasswordSubmit = async (e) => {
//     e.preventDefault();
//     if (passwordData.password !== passwordData.confirmPassword) {
//       alert("❌ Passwords do not match!");
//       return;
//     }
    
//     try {
//       const token = localStorage.getItem("token");
      
//       // Changed to match the backend: 
//       // PATCH request to /api/v1/users/{userId} with the password payload
//       await axios.patch(
//         `${API_URL}/api/v1/users/${passwordUser.id}`,
//         { 
//           password: passwordData.password 
//         },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
      
//       alert(`✅ Password changed for ${passwordUser.firstName}`);
//       setPasswordUser(null);
//     } catch (err) {
//       console.error("Error changing password:", err);
//       // Enhanced error handling to catch permission errors (like updating oneself)
//       const errorMessage = err.response?.data?.message || "Failed to change password.";
//       alert(`❌ ${errorMessage}`);
//     }
//   };

//   const handleSuspend = (user) => {
//     const code = Math.random().toString(36).substring(2, 7).toUpperCase();
//     setGeneratedCode(code);
//     setConfirmCode("");
//     setSuspendUser(user);
//   };

//   const confirmSuspend = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       // Using the same PATCH logic as Edit to update 'active' status
//       await axios.patch(`${API_URL}/api/v1/users/${suspendUser.id}`, 
//         { active: false }, 
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       alert(`User ${suspendUser.firstName} has been suspended.`);
//       setSuspendUser(null);
//       window.location.reload(); 
//     } catch (error) {
//       console.error("Error suspending user:", error);
//       alert("Failed to suspend user.");
//     }
//   };

//   // --- SMS Pricing Functions ---
//   const fetchSmsPrice = async (user) => {
//     if (!user) return;
//     setSmsPriceLoading(true);
//     try {
//       const token = localStorage.getItem("token");
      
//       // 1. Fetch the user's current profile to get the existing smsRate
//       const response = await axios.get(`${API_URL}/api/v1/users/${user.id}`, {
//         headers: { Authorization: `Bearer ${token}` }
//       });
      
//       // Extract the smsRate from the ApiResponse wrapper (response.data.data)
//       const userData = response.data?.data || {};
      
//       setSmsPriceData({
//         current: userData.smsRate !== null && userData.smsRate !== undefined ? userData.smsRate : 0,
//         new: ""
//       });
//     } catch (error) {
//       console.error("Error fetching SMS price:", error);
//       alert("Failed to fetch current SMS price.");
//       setSmsPriceData(prev => ({ ...prev, current: "Error" }));
//     } finally {
//       setSmsPriceLoading(false);
//     }
//   };

//   const handleOpenSmsPricing = (user) => {
//     setSmsPricingUser(user);
//     fetchSmsPrice(user);
//     setActiveDropdown(null);
//   };

//   const handleUpdateSmsPrice = async () => {
//     if (!smsPriceData.new) {
//       alert("Please enter a new price value.");
//       return;
//     }
//     setSmsUpdateLoading(true);
//     try {
//       const token = localStorage.getItem("token");
      
//       // 2. Use the PATCH API and the correct payload key: 'smsRate'
//       await axios.patch(
//         `${API_URL}/api/v1/users/${smsPricingUser.id}`,
//         { smsRate: parseFloat(smsPriceData.new) },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
      
//       alert("SMS Price updated successfully!");
//       setSmsPriceData(prev => ({ ...prev, current: prev.new, new: "" }));
      
//       // Optional: Update the user list state if you display the rate in the main table
//     } catch (error) {
//       console.error("Error updating SMS price:", error);
//       alert("Failed to update SMS price.");
//     } finally {
//       setSmsUpdateLoading(false);
//     }
//   };

//   // --- Funds Functions ---
//   const handleOpenFunds = (user) => {
//     setFundsUser(user);
//     setFundsData({
//       amount: "",
//       action: "CREDIT"
//     });
//     setActiveDropdown(null);
//   };

//   const handleFundsSubmit = async (e) => {
//     e.preventDefault();
//     if (!fundsData.amount || parseFloat(fundsData.amount) <= 0) {
//       alert("Please enter a valid amount.");
//       return;
//     }

//     setFundsLoading(true);
//     try {
//       const token = localStorage.getItem("token");
//       // Convert Rupee amount to Paise (1 Rupee = 100 Paise)
//       const amountPaise = Math.round(parseFloat(fundsData.amount) * 100);

//       if (fundsData.action === "DEBIT") {
//         // Integrate Revoke API
//         await axios.post(
//           `${API_URL}/api/v1/wallet/revoke`,
//           {
//             targetUserId: fundsUser.id,
//             amountPaise: amountPaise
//           },
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//         alert(`Debited ₹${fundsData.amount} successfully!`);
//       } else {
//         // Integrate Recharge API
//         await axios.post(
//           `${API_URL}/api/v1/wallet/recharge`,
//           {
//             targetUserId: fundsUser.id,
//             amountPaise: amountPaise
//           },
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//         alert(`Credited ₹${fundsData.amount} successfully!`);
//       }

//       // Clear cached balance for this user to force refresh
//       setBalances(prev => {
//         const newBalances = { ...prev };
//         delete newBalances[fundsUser.id];
//         return newBalances;
//       });

//       setFundsUser(null);
//       setFundsData({
//         amount: "",
//         action: "CREDIT"
//       });
//     } catch (error) {
//       console.error("Error processing transaction:", error);
//       alert(error.response?.data?.message || "Failed to process transaction.");
//     } finally {
//       setFundsLoading(false);
//     }
//   };

//   // --- History Functions ---
//   const handleOpenHistory = async (user) => {
//     setHistoryUser(user);
//     setHistoryLoading(true);
//     setActiveDropdown(null);

//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.get(
//         `${API_URL}/api/billing/history/${user.id}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       setTransactions(response.data || []);
//     } catch (error) {
//       console.error("Error fetching transaction history:", error);
//       setTransactions([]);
//     } finally {
//       setHistoryLoading(false);
//     }
//   };

//   const formatDate = (timestamp) => {
//     if (Array.isArray(timestamp) && timestamp.length >= 6) {
//       const [year, month, day, hour, minute, second] = timestamp;
//       const date = new Date(year, month - 1, day, hour, minute, second);
//       return date.toLocaleDateString('en-US', {
//         year: 'numeric',
//         month: 'short',
//         day: 'numeric',
//         hour: '2-digit',
//         minute: '2-digit',
//         second: '2-digit'
//       });
//     }

//     const date = new Date(timestamp);
//     if (isNaN(date.getTime())) {
//       return "Invalid Date";
//     }
//     return date.toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//       second: '2-digit'
//     });
//   };

//   // Role-based filter options
//   const filterOptions = useMemo(() => {
//     if (userRole === "SUPER_SUPER_ADMIN")
//       return ["ALL", "SUPER_ADMIN", "RESELLER", "COMPANY"];
//     if (userRole === "SUPER_ADMIN") return ["ALL", "RESELLER", "COMPANY"];
//     if (userRole === "RESELLER") return ["ALL", "COMPANY"];
//     return ["ALL"];
//   }, [userRole]);

//   // Filtering and Searching Logic
//   const filteredUsers = useMemo(() => {
//     let filteredByType = users;

//     if (userRole === "SUPER_ADMIN") {
//       filteredByType = filteredByType.filter(
//         (user) => user.accountType === "RESELLER" || user.accountType === "COMPANY"
//       );
//     } else if (userRole === "RESELLER") {
//       filteredByType = filteredByType.filter(
//         (user) => user.accountType === "COMPANY"
//       );
//     }

//     if (filterType !== "ALL") {
//       filteredByType = filteredByType.filter((user) => user.accountType === filterType);
//     }

//     const lowerCaseSearchTerm = searchTerm.toLowerCase();
//     const result = filteredByType.filter((user) =>
//       Object.values(user).some(
//         (value) =>
//           value &&
//           value.toString().toLowerCase().includes(lowerCaseSearchTerm)
//       )
//     );
//     return result;
//   }, [users, filterType, searchTerm, userRole]);


//   const sortedUsers = [...filteredUsers].sort((a, b) => {
//     if (!a.idValidFrom || !b.idValidFrom) return 0;
//     const dateA = new Date(a.idValidFrom[0], a.idValidFrom[1] - 1, a.idValidFrom[2]);
//     const dateB = new Date(b.idValidFrom[0], b.idValidFrom[1] - 1, b.idValidFrom[2]);

//     if (dateB.getTime() !== dateA.getTime()) {
//       return dateB - dateA;
//     }
//     return b.id.localeCompare(a.id);
//   });

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = sortedUsers.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredUsers.length / itemsPerPage) || 1;

//   const nextPage = () => {
//     if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
//   };
//   const prevPage = () => {
//     if (currentPage > 1) setCurrentPage((prev) => prev - 1);
//   };

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [filterType, searchTerm]);

//   const activeCount = filteredUsers.filter(u => u.accountStatus?.toLowerCase() === 'active').length;
//   const resellerCount = filteredUsers.filter(u => u.accountType === 'RESELLER').length;
  
//   const getDropdownPosition = (userId) => {
//     const button = buttonRefs.current[userId];
//     if (!button) return { top: 0, left: 0 };
    
//     const rect = button.getBoundingClientRect();
//     const dropdownHeight = 140; 
//     const dropdownWidth = 256; 
    
//     let top = rect.top - dropdownHeight - 10; 
//     let left = rect.left - (dropdownWidth / 2) + (rect.width / 2); 
    
//     if (top < 10) top = 10; 
//     if (left < 10) left = 10; 
//     if (left + dropdownWidth > window.innerWidth - 10) {
//       left = window.innerWidth - dropdownWidth - 10;
//     }
    
//     return { top, left };
//   };

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (activeDropdown && !e.target.closest('.dropdown-container')) {
//         setActiveDropdown(null);
//       }
//     };
    
//     document.addEventListener('click', handleClickOutside);
//     return () => document.removeEventListener('click', handleClickOutside);
//   }, [activeDropdown]);

//   return (
//     <div className="min-h-screen bg-[#f0EFEB] font-sans overflow-auto">
//       <div className="max-w-7xl mx-auto p-3 md:p-5">

//         {/* Header Card */}
//         <div className="bg-[#0C4550] rounded-2xl shadow-2xl mb-5 p-5 md:p-6">
//           <div className="flex flex-col md:flex-row md:items-center justify-between">
//             <div className="flex items-center gap-4 mb-4 md:mb-0">
//               <div className="w-14 h-14 bg-white/10 backdrop-blur-sm rounded-xl flex items-center justify-center border border-[#C5F637]/30">
//                 <Users className="h-8 w-8 text-white" />
//               </div>
//               <div>
//                 <h1 className="text-2xl md:text-3xl font-bold text-white">Account Management Console</h1>
//                 <p className="text-[#A7A08F] mt-1 font-medium">View and manage all user accounts in the system</p>
//               </div>
//             </div>

//             <div className="flex flex-wrap gap-3">
//               <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 min-w-[120px] border border-white/5">
//                 <div className="flex items-center gap-2 text-white mb-1">
//                   <Users className="h-4 w-4 text-[#C5F637]" />
//                   <span className="text-sm font-medium text-white">TOTAL</span>
//                 </div>
//                 <div className="text-2xl font-bold text-white">{filteredUsers.length}</div>
//               </div>

//               <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 min-w-[120px] border border-white/5">
//                 <div className="flex items-center gap-2 text-white mb-1">
//                   <CheckCircle className="h-4 w-4 text-[#C5F637]" />
//                   <span className="text-sm font-medium text-white">ACTIVE</span>
//                 </div>
//                 <div className="text-2xl font-bold text-white">{activeCount}</div>
//               </div>

//               {(userRole === 'SUPER_ADMIN' || userRole === 'SUPER_SUPER_ADMIN') && (
//                 <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 min-w-[120px] border border-white/5">
//                   <div className="flex items-center gap-2 text-white mb-1">
//                     <Globe className="h-4 w-4 text-[#C5F637]" />
//                     <span className="text-sm font-medium text-white">RESELLERS</span>
//                   </div>
//                   <div className="text-2xl font-bold text-white">{resellerCount}</div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Filters & Search Section */}
//         <div className="bg-white rounded-2xl shadow-lg mb-5 p-5  border border-gray-200">
//           <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
//             <div className="bg-gray-50 p-1 rounded-xl w-full flex gap-3 flex-col  md:flex-row  border border-gray-200 shadow-inner  overflow-x-auto">
//               {filterOptions.map((type) => (
//                 <button
//                   key={type}
//                   onClick={() => setFilterType(type)}
//                   className={`px-4 py-2 rounded-xl  text-sm font-semibold transition-all duration-300 flex items-center gap-2 whitespace-nowrap ${filterType === type
//                     ? "bg-[#0C4550] text-[#C5F637] shadow-md border border-[#0C4550]"
//                     : "text-gray-600 hover:bg-gray-100"
//                     }`}
//                 >
//                   {type === "SUPER_ADMIN" && <Shield size={14} />}
//                   {type === "RESELLER" && <Globe size={14} />}
//                   {type === "COMPANY" && <Briefcase size={14} />}
//                   {type === "ALL" && <Users size={14} />}
//                   {type === "ALL" ? "All Accounts" : type.replace("_", " ")}
//                 </button>
//               ))}
//             </div>

//             <div className="relative w-full md:w-80">
//               <input
//                 type="text"
//                 placeholder="Search by name, email, company..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="w-full pl-12 pr-4 py-3 rounded-xl border border-gray-300 bg-white text-sm text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-[#126673] outline-none transition-all duration-300 hover:border-[#0C4550]/50 shadow-sm"
//               />
//               <div className="absolute inset-y-0 left-4 flex items-center pointer-events-none text-[#0C4550]">
//                 <Search size={20} />
//               </div>
//               {searchTerm && (
//                 <button
//                   onClick={() => setSearchTerm('')}
//                   className="absolute inset-y-0 right-3 flex items-center text-gray-400 hover:text-[#0C4550] transition-colors"
//                 >
//                   <X size={16} />
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Main Content - Table */}
//         <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-200">
//           <div className="overflow-x-auto">
//             <table className="min-w-full divide-y divide-gray-200">
//               <thead className="bg-gray-50">
//                 <tr>
//                   {["User / Company", "Contact Info", "Type", "Status", "Wallet", "Transactions", "Manage"].map((header, i) => (
//                     <th
//                       key={i}
//                       className={`px-4 py-3 text-left text-xs font-bold text-[#0C4550] uppercase tracking-wider ${i === 6 ? 'text-center' : ''}`}
//                     >
//                       {header}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-200 bg-white">
//                 {loading ? (
//                   <tr>
//                     <td colSpan={7} className="py-20 text-center">
//                       <div className="inline-block animate-spin rounded-full h-10 w-10 border-4 border-gray-200 border-t-[#0C4550]"></div>
//                       <p className="mt-3 text-sm text-gray-600">Loading accounts...</p>
//                     </td>
//                   </tr>
//                 ) : currentItems.length === 0 ? (
//                   <tr>
//                     <td colSpan={7} className="py-16 text-center">
//                       <div className="flex flex-col items-center justify-center">
//                         <Users className="h-16 w-16 text-gray-300 mb-4" />
//                         <p className="text-gray-500 text-lg font-medium">No accounts found</p>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : (
//                   currentItems.map((user) => {
//                     const position = activeDropdown === user.id ? getDropdownPosition(user.id) : { top: 0, left: 0 };
                    
//                     return (
//                       <tr
//                         key={user.id}
//                         className="hover:bg-gray-100 transition-colors duration-200 group border-l-2 border-transparent hover:border-[#C5F637]"
//                       >
//                         {/* User Profile */}
//                         <td className="px-4 py-3 whitespace-nowrap">
//                           <div className="flex items-center gap-3">
//                             <div className="w-9 h-9 rounded-full bg-white border-2 border-[#0C4550] text-[#0C4550] flex items-center justify-center font-bold text-xs shadow-md">
//                               {user.firstName?.charAt(0)}{user.lastName?.charAt(0)}
//                             </div>
//                             <div>
//                               <div className="font-bold text-gray-800 text-sm">{user.firstName} {user.lastName}</div>
//                               {user.companyName && (
//                                 <div className="text-xs text-gray-600 font-medium">{user.companyName}</div>
//                               )}
//                             </div>
//                           </div>
//                         </td>

//                         {/* Contact */}
//                         <td className="px-4 py-3 whitespace-nowrap">
//                           <div className="flex flex-col gap-0.5">
//                             <div className="flex items-center gap-2 text-gray-800">
//                               <Mail size={12} className="text-[#A7A08F]" />
//                               <span className="text-xs truncate max-w-[180px]">{user.email}</span>
//                             </div>
//                             {user.phone && (
//                               <div className="flex items-center gap-2 text-gray-600">
//                                 <Phone size={12} className="text-[#A7A08F]" />
//                                 <span className="text-xs">{user.phone}</span>
//                               </div>
//                             )}
//                           </div>
//                         </td>

//                         {/* Type */}
//                         <td className="px-4 py-3 whitespace-nowrap">
//                           <div className="flex flex-col items-start gap-1">
//                             {getTypeBadge(user.accountType)}
//                           </div>
//                         </td>

//                         {/* Status */}
//                         <td className="px-4 py-3 whitespace-nowrap">
//                           <div className="flex flex-col gap-1 items-start">
//                             {getStatusBadge(user.accountStatus)}
//                             {user.validTo && (
//                               <div className="text-[10px] text-gray-500 flex items-center gap-1">
//                                 <Clock size={10} />
//                                 {new Date(user.validTo).toLocaleDateString()}
//                               </div>
//                             )}
//                           </div>
//                         </td>

//                         {/* Wallet */}
//                         <td className="px-4 py-3 whitespace-nowrap">
//                           <div className="flex items-center">
//                             {balances[user.id] !== undefined ? (
//                               <div className="flex items-center gap-1 bg-[#0C4550]/5 border border-[#0C4550]/20 px-2.5 py-1.5 rounded-lg">
//                                 <span className="text-sm font-bold text-[#0C4550] flex items-center">
//                                   <IndianRupee className="inline mr-0.5" size={12} />
//                                   {balances[user.id]}
//                                 </span>
//                               </div>
//                             ) : (
//                               <button
//                                 className="text-xs font-semibold text-[#0C4550] hover:text-[#136C7A] flex items-center gap-1 hover:underline disabled:opacity-50 disabled:cursor-wait"
//                                 onClick={() => handleFetchBalance(user.id)}
//                                 disabled={balanceLoading[user.id]}
//                               >
//                                 {balanceLoading[user.id] ? (
//                                   <Loader size={12} className="animate-spin text-[#C5F637]" />
//                                 ) : (
//                                   <IndianRupee size={12} className="text-gray-800" />
//                                 )}
//                                 {balanceLoading[user.id] ? "..." : "Check"}
//                               </button>
//                             )}
//                           </div>
//                         </td>

//                         {/* Transactions Dropdown */}
//                         <td className="px-4 py-3 whitespace-nowrap dropdown-container">
//                           <div className="relative">
//                             <button
//                               ref={(el) => { if (el) buttonRefs.current[user.id] = el; }}
//                               onClick={() => setActiveDropdown(activeDropdown === user.id ? null : user.id)}
//                               className="flex items-center gap-1.5 bg-[#0C4550] text-white rounded-full px-3 py-1.5 hover:bg-[#0A3A43] transition-all duration-200 shadow-md font-medium text-xs"
//                             >
//                               <span>Action</span>
//                               <ChevronDown size={14} className={`transform transition-transform duration-200 ${activeDropdown === user.id ? 'rotate-180' : ''}`} />
//                             </button>

//                             {activeDropdown === user.id && (
//                               <div 
//                                 className="fixed z-[9999] dropdown-container"
//                                 style={{ top: `${position.top}px`, left: `${position.left}px` }}
//                               >
//                                 <div className="w-64 bg-[#EEF2FC] border border-gray-300 rounded-2xl shadow-2xl animate-fadeIn">
//                                   <div className="p-4">
//                                     <div className="flex justify-between items-center gap-3">
//                                       {/* SMS Pricing */}
//                                       <button
//                                         onClick={() => handleOpenSmsPricing(user)}
//                                         className="flex flex-col items-center gap-2 p-3 hover:bg-[#0C4550]/5 transition-all rounded-xl group flex-1"
//                                       >
//                                         <div className="w-10 h-10 rounded-full bg-[#0C4550]/10 text-[#0C4550] flex items-center justify-center group-hover:bg-[#0C4550] group-hover:text-[#C5F637] transition-all duration-200">
//                                           <IndianRupee size={20} />
//                                         </div>
//                                         <div className="text-center">
//                                           <div className="font-semibold text-gray-800 text-xs">Pricing</div>
//                                         </div>
//                                       </button>
//                                       {/* Funds */}
//                                       <button
//                                         onClick={() => handleOpenFunds(user)}
//                                         className="flex flex-col items-center gap-2 p-3 hover:bg-[#0C4550]/5 transition-all rounded-xl group flex-1"
//                                       >
//                                         <div className="w-10 h-10 rounded-full bg-[#0C4550]/10 text-[#0C4550] flex items-center justify-center group-hover:bg-[#0C4550] group-hover:text-[#C5F637] transition-all duration-200">
//                                           <CreditCard size={20} />
//                                         </div>
//                                         <div className="text-center">
//                                           <div className="font-semibold text-gray-800 text-xs">Funds</div>
//                                         </div>
//                                       </button>
//                                       {/* History */}
//                                       <button
//                                         onClick={() => handleOpenHistory(user)}
//                                         className="flex flex-col items-center gap-2 p-3 hover:bg-[#0C4550]/5 transition-all rounded-xl group flex-1"
//                                       >
//                                         <div className="w-10 h-10 rounded-full bg-[#0C4550]/10 text-[#0C4550] flex items-center justify-center group-hover:bg-[#0C4550] group-hover:text-[#C5F637] transition-all duration-200">
//                                           <History size={20} />
//                                         </div>
//                                         <div className="text-center">
//                                           <div className="font-semibold text-gray-800 text-xs"> History</div>
//                                         </div>
//                                       </button>
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
//                             )}
//                           </div>
//                         </td>

//                         {/* Actions */}
//                         <td className="px-4 py-3 whitespace-nowrap text-right">
//                           <div className="flex items-center justify-end gap-1">
//                             <button
//                               onClick={() => handleEdit(user)}
//                               className="p-2 text-[#0C4550] hover:bg-[#0C4550]/5 rounded-xl transition-colors border border-transparent hover:border-[#0C4550]/20"
//                               title="Edit Account"
//                             >
//                               <Edit size={16} />
//                             </button>
//                             <button
//                               onClick={() => handleChangePassword(user)}
//                               className="p-2 text-[#0C4550] hover:bg-[#0C4550]/5 rounded-xl transition-colors border border-transparent hover:border-[#0C4550]/20"
//                               title="Change Password"
//                             >
//                               <Key size={16} />
//                             </button>
//                             <button
//                               onClick={() => handleSuspend(user)}
//                               className="p-2 text-red-600 hover:bg-red-50 rounded-xl transition-colors border border-transparent hover:border-red-200"
//                               title="Suspend Account"
//                             >
//                               <UserMinus size={16} />
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* Pagination */}
//           <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between">
//             <span className="text-sm text-gray-700 font-medium">
//               Showing {indexOfFirstItem + 1} - {Math.min(indexOfLastItem, filteredUsers.length)} of {filteredUsers.length} accounts
//             </span>
//             <div className="flex items-center gap-3">
//               <button
//                 onClick={prevPage}
//                 disabled={currentPage === 1}
//                 className={`p-2.5 rounded-xl border transition-all ${currentPage === 1
//                   ? "border-gray-200 text-gray-300 cursor-not-allowed bg-gray-50"
//                   : "border-gray-300 text-gray-700 hover:bg-white hover:border-[#0C4550] hover:text-[#0C4550] active:scale-95 shadow-sm"
//                   }`}
//               >
//                 <ChevronLeft size={20} />
//               </button>
//               <span className="text-sm text-gray-800 font-semibold px-3">
//                 Page {currentPage} of {totalPages}
//               </span>
//               <button
//                 onClick={nextPage}
//                 disabled={currentPage === totalPages}
//                 className={`p-2.5 rounded-xl border transition-all ${currentPage === totalPages
//                   ? "border-gray-200 text-gray-300 cursor-not-allowed bg-gray-50"
//                   : "border-gray-300 text-gray-700 hover:bg-white hover:border-[#0C4550] hover:text-[#0C4550] active:scale-95 shadow-sm"
//                   }`}
//               >
//                 <ChevronRight size={20} />
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* --- MODALS --- */}

//       {/* EDIT MODAL */}
//       {editingUser && (
//         <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4 overflow-y-auto">
//           <div className="bg-[#f0EFEB] rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col my-4">
//             <div className="bg-[#0C4550] p-6 rounded-t-2xl border-b border-[#C5F637]/20 sticky top-0 z-10">
//               <div className="flex justify-between items-center">
//                 <h3 className="text-xl font-bold text-white">Edit Account Details</h3>
//                 <button
//                   onClick={closeModal}
//                   className="text-white/80 hover:text-[#C5F637] p-1.5 rounded-full hover:bg-white/10 transition-colors"
//                 >
//                   <X size={24} />
//                 </button>
//               </div>
//             </div>
            
//             <div className="p-6 overflow-y-auto flex-1">
//               {editLoading ? (
//                 <div className="text-center py-10">
//                   <div className="inline-block animate-spin rounded-full h-8 w-8 border-4 border-gray-200 border-t-[#0C4550]"></div>
//                   <p className="mt-3 text-gray-600">Loading user data...</p>
//                 </div>
//               ) : (
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  
//                   {/* Personal Information */}
//                   <div className="md:col-span-2">
//                     <h4 className="text-lg font-bold text-[#0C4550] mb-4 pb-2 border-b border-[#0C4550]/20">Personal Information</h4>
//                   </div>
                  
//                   {[
//                     ["First Name", "firstName", "text"],
//                     ["Last Name", "lastName", "text"],
//                   ].map(([lbl, key, type]) => (
//                     <div key={key} className="group">
//                       <label className="block text-sm font-semibold text-gray-700 mb-2">{lbl}</label>
//                       <input
//                         type={type}
//                         value={formData[key] || ""}
//                         onChange={(e) => setFormData({ ...formData, [key]: e.target.value })}
//                         className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
//                       />
//                     </div>
//                   ))}

//                   <div className="group">
//                     <label className="block text-sm font-semibold text-gray-700 mb-2">Email (Read-Only)</label>
//                     <input
//                       type="email"
//                       value={formData.email || ""}
//                       readOnly
//                       className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-gray-100 text-gray-500 cursor-not-allowed"
//                     />
//                   </div>

//                   <div className="group">
//                     <label className="block text-sm font-semibold text-gray-700 mb-2">Phone</label>
//                     <input
//                       type="text"
//                       value={formData.phone || ""}
//                       onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
//                       className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
//                     />
//                   </div>

//                   {/* Business Information */}
//                   <div className="md:col-span-2 mt-2">
//                     <h4 className="text-lg font-bold text-[#0C4550] mb-4 pb-2 border-b border-[#0C4550]/20">Business Information</h4>
//                   </div>

//                   <div className="group">
//                     <label className="block text-sm font-semibold text-gray-700 mb-2">Company Name</label>
//                     <input
//                       type="text"
//                       value={formData.companyName || ""}
//                       onChange={(e) => setFormData({ ...formData, companyName: e.target.value })}
//                       className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
//                     />
//                   </div>

//                   <div className="group">
//                     <label className="block text-sm font-semibold text-gray-700 mb-2">Company Type</label>
//                     <input
//                       type="text"
//                       value={formData.companyType || ""}
//                       onChange={(e) => setFormData({ ...formData, companyType: e.target.value })}
//                       className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
//                     />
//                   </div>

//                   <div className="group">
//                     <label className="block text-sm font-semibold text-gray-700 mb-2">GST Number</label>
//                     <input
//                       type="text"
//                       value={formData.gstNumber || ""}
//                       onChange={(e) => setFormData({ ...formData, gstNumber: e.target.value.toUpperCase() })}
//                       className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
//                     />
//                   </div>

//                   <div className="group">
//                     <label className="block text-sm font-semibold text-gray-700 mb-2">PAN Number</label>
//                     <input
//                       type="text"
//                       value={formData.panNumber || ""}
//                       onChange={(e) => setFormData({ ...formData, panNumber: e.target.value.toUpperCase() })}
//                       className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
//                     />
//                   </div>

//                   <div className="group md:col-span-2">
//                     <label className="block text-sm font-semibold text-gray-700 mb-2">Address</label>
//                     <textarea
//                       value={formData.address || ""}
//                       onChange={(e) => setFormData({ ...formData, address: e.target.value })}
//                       className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
//                       rows="2"
//                     />
//                   </div>

//                   {/* Validity & Account Info */}
//                   <div className="md:col-span-2 mt-2">
//                     <h4 className="text-lg font-bold text-[#0C4550] mb-4 pb-2 border-b border-[#0C4550]/20">Account Configuration & Status</h4>
//                   </div>

//                   <div className="group">
//                     <label className="block text-sm font-semibold text-gray-700 mb-2">Valid From</label>
//                     <input
//                       type="date"
//                       value={formData.validFrom || ""}
//                       onChange={(e) => setFormData({ ...formData, validFrom: e.target.value })}
//                       className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
//                     />
//                   </div>

//                   <div className="group">
//                     <label className="block text-sm font-semibold text-gray-700 mb-2">Valid To</label>
//                     <input
//                       type="date"
//                       value={formData.validTo || ""}
//                       onChange={(e) => setFormData({ ...formData, validTo: e.target.value })}
//                       className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
//                     />
//                   </div>
                  
//                   <div className="group">
//                     <label className="block text-sm font-semibold text-gray-700 mb-2">Role (Read-Only)</label>
//                     <input
//                       type="text"
//                       value={formData.role || ""}
//                       readOnly
//                       className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-gray-100 text-gray-500 font-bold cursor-not-allowed"
//                     />
//                   </div>

//                   {/* ACTIVE STATUS TOGGLE */}
//                   <div className="group">
//                     <label className="block text-sm font-semibold text-gray-700 mb-2">Account Status</label>
//                     <select
//                       value={formData.active !== undefined ? String(formData.active) : "true"}
//                       onChange={(e) => setFormData({ ...formData, active: e.target.value === "true" })}
//                       className={`w-full px-4 py-3 rounded-xl border-2 bg-white focus:outline-none focus:ring-2 transition-all duration-200 shadow-sm font-bold ${
//                         formData.active 
//                           ? "border-emerald-200 text-emerald-700 focus:border-emerald-400 focus:ring-emerald-200" 
//                           : "border-red-200 text-red-700 focus:border-red-400 focus:ring-red-200"
//                       }`}
//                     >
//                       <option value="true">Active (Enabled)</option>
//                       <option value="false">Inactive (Disabled)</option>
//                     </select>
//                   </div>

//                 </div>
//               )}
//             </div>
            
//             {/* Modal Footer */}
//             <div className="p-6 border-t border-gray-200 bg-gray-50 rounded-b-2xl flex justify-end gap-3">
//               <button
//                 onClick={closeModal}
//                 className="px-6 py-3 text-sm font-semibold text-gray-700 bg-white border-2 border-gray-300 rounded-xl hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 shadow-sm"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleUpdate}
//                 disabled={editLoading}
//                 className="px-8 py-3 text-sm font-semibold text-[#C5F637] bg-[#0C4550] rounded-xl hover:bg-[#0A3A43] transition-all duration-200 shadow-lg hover:shadow-xl disabled:opacity-50"
//               >
//                 Save Changes
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* PASSWORD MODAL (EXPLICIT FLOW) */}
//       {passwordUser && (
//         <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
//           <div className="bg-[#f0EFEB] rounded-2xl shadow-2xl w-full max-w-md">
//             <div className="bg-[#0C4550] p-6 rounded-t-2xl border-b border-[#C5F637]/20">
//               <div className="flex justify-between items-center">
//                 <h3 className="text-xl font-bold text-white">Change Password</h3>
//                 <button
//                   onClick={() => setPasswordUser(null)}
//                   className="text-white/80 hover:text-[#C5F637] p-1.5 rounded-full hover:bg-white/10 transition-colors"
//                 >
//                   <X size={24} />
//                 </button>
//               </div>
//             </div>
//             <form onSubmit={handlePasswordSubmit} className="p-6 space-y-5">
//               <div className="flex items-center gap-4 p-4 bg-[#0C4550]/5 rounded-xl border border-[#0C4550]/20">
//                 <div className="w-12 h-12 rounded-xl bg-[#0C4550] text-[#C5F637] flex items-center justify-center text-lg font-bold">
//                   {passwordUser?.firstName?.[0]}{passwordUser?.lastName?.[0]}
//                 </div>
//                 <div className="text-sm font-medium text-gray-800">
//                   Changing password for <span className="font-bold">{passwordUser?.firstName} {passwordUser?.lastName}</span>
//                 </div>
//               </div>
//               <div className="group">
//                 <input
//                   type="password"
//                   placeholder="New Password"
//                   className="w-full px-4 py-3.5 rounded-xl border-2 border-gray-200 text-sm focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
//                   value={passwordData.password}
//                   onChange={(e) => setPasswordData({ ...passwordData, password: e.target.value })}
//                   required
//                 />
//               </div>
//               <div className="group">
//                 <input
//                   type="password"
//                   placeholder="Confirm Password"
//                   className="w-full px-4 py-3.5 rounded-xl border-2 border-gray-200 text-sm focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
//                   value={passwordData.confirmPassword}
//                   onChange={(e) => setPasswordData({ ...passwordData, confirmPassword: e.target.value })}
//                   required
//                 />
//               </div>
//               <button
//                 type="submit"
//                 className="w-full py-3.5 text-sm font-semibold text-[#C5F637] bg-[#0C4550] rounded-xl hover:bg-[#0A3A43] transition-all duration-200 shadow-lg hover:shadow-xl"
//               >
//                 Update Password
//               </button>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* SUSPEND MODAL */}
//       {suspendUser && (
//         <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
//           <div className="bg-[#f0EFEB] rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden">
//             <div className="bg-gradient-to-r from-red-500 to-red-600 p-6 relative">
//               <h3 className="font-bold text-white flex items-center gap-2">
//                 <AlertCircle size={20} /> Suspend Account
//               </h3>
//               <button
//                 onClick={() => setSuspendUser(null)}
//                 className="absolute top-4 right-4 text-white/80 hover:text-white p-1.5 rounded-full hover:bg-white/10 transition-colors"
//               >
//                 <X size={20} />
//               </button>
//             </div>
//             <div className="p-6">
//               <div className="flex items-center gap-4 mb-4 p-4 bg-red-50 rounded-xl border border-red-200">
//                 <div className="w-12 h-12 rounded-xl bg-[#0C4550] text-white flex items-center justify-center text-lg font-bold">
//                   {suspendUser?.firstName?.[0]}{suspendUser?.lastName?.[0]}
//                 </div>
//                 <div className="text-sm font-medium text-gray-800">
//                   Suspending account for <span className="font-bold">{suspendUser?.firstName} {suspendUser?.lastName}</span>
//                 </div>
//               </div>
//               <p className="text-sm text-gray-700 mb-4">
//                 The user will no longer be able to log in. To confirm suspension, please type the code below:
//               </p>
//               <div className="bg-red-50 text-red-700 text-center font-mono text-2xl font-extrabold py-4 rounded-xl border border-red-200 mb-4 select-none tracking-wider">
//                 {generatedCode}
//               </div>
//               <input
//                 type="text"
//                 placeholder="Enter confirmation code"
//                 className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl text-center font-mono uppercase outline-none focus:border-red-500 focus:ring-2 focus:ring-red-100 transition-all duration-200 shadow-sm"
//                 value={confirmCode}
//                 onChange={(e) => setConfirmCode(e.target.value.toUpperCase())}
//               />
//               <button
//                 onClick={confirmSuspend}
//                 disabled={confirmCode !== generatedCode}
//                 className={`w-full mt-5 py-3.5 rounded-xl text-sm font-semibold text-white transition-all duration-200 shadow-lg ${
//                   confirmCode === generatedCode
//                     ? "bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700"
//                     : "bg-gray-300 cursor-not-allowed"
//                 }`}
//               >
//                 Confirm Suspend
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* SMS Pricing Modal */}
//       {smsPricingUser && (
//         <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
//           <div className="bg-[#f0EFEB] rounded-2xl shadow-2xl w-full max-w-md">
//             <div className="bg-[#0C4550] p-6 rounded-t-2xl border-b border-[#C5F637]/20">
//               <div className="flex justify-between items-center">
//                 <div>
//                   <h3 className="text-xl font-bold text-white flex items-center gap-2">
//                     <IndianRupee /> SMS Pricing
//                   </h3>
//                   <p className="text-[#A7A08F] text-sm mt-1">
//                     For: {smsPricingUser.firstName} {smsPricingUser.lastName}
//                   </p>
//                 </div>
//                 <button
//                   onClick={() => setSmsPricingUser(null)}
//                   className="text-white/80 hover:text-[#C5F637] p-1.5 rounded-full hover:bg-white/10 transition-colors"
//                 >
//                   <X size={24} />
//                 </button>
//               </div>
//             </div>

//             <div className="p-6 space-y-6">
//               <div className="flex items-start gap-3 p-4 bg-[#0C4550]/5 border border-[#0C4550]/20 rounded-xl text-[#0C4550] text-sm">
//                 <Info className="mt-0.5 flex-shrink-0" size={16} />
//                 <p>Update the cost per SMS for this specific user. This will override default system rates.</p>
//               </div>

//               {smsPriceLoading ? (
//                 <div className="py-8 flex flex-col items-center justify-center text-gray-500">
//                   <Loader className="animate-spin mb-2" size={24} />
//                   <span>Fetching current rates...</span>
//                 </div>
//               ) : (
//                 <>
//                   <div className="group">
//                     <label className="block text-sm font-semibold text-gray-700 mb-2">Current SMS Cost</label>
//                     <div className="relative">
//                       <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
//                         <IndianRupee className="text-gray-400" />
//                       </div>
//                       <input
//                         type="text"
//                         value={smsPriceData.current}
//                         readOnly
//                         className="w-full pl-10 pr-4 py-3 rounded-xl border-2 border-gray-200 bg-gray-100 text-gray-500 cursor-not-allowed font-medium shadow-inner"
//                       />
//                     </div>
//                   </div>

//                   <div className="group">
//                     <label className="block text-sm font-semibold text-gray-700 mb-2">New SMS Cost</label>
//                     <div className="relative">
//                       <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
//                         <IndianRupee className="text-[#0C4550]" />
//                       </div>
//                       <input
//                         type="number"
//                         step="0.01"
//                         min="0"
//                         placeholder="0.00"
//                         value={smsPriceData.new}
//                         onChange={(e) => setSmsPriceData({ ...smsPriceData, new: e.target.value })}
//                         className="w-full pl-10 pr-4 py-3 rounded-xl border-2 border-[#0C4550]/20 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
//                       />
//                     </div>
//                   </div>

//                   <div className="flex gap-3 pt-2">
//                     <button
//                       onClick={() => setSmsPricingUser(null)}
//                       className="flex-1 py-3.5 text-sm font-semibold text-gray-700 bg-white border-2 border-gray-300 rounded-xl hover:bg-gray-50 hover:border-gray-400 transition-all duration-200"
//                     >
//                       Cancel
//                     </button>
//                     <button
//                       onClick={handleUpdateSmsPrice}
//                       disabled={smsUpdateLoading || !smsPriceData.new}
//                       className="flex-1 py-3.5 text-sm font-semibold text-[#C5F637] bg-[#0C4550] rounded-xl hover:bg-[#0A3A43] transition-all duration-200 shadow-lg flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
//                     >
//                       {smsUpdateLoading ? <><Loader className="animate-spin" /> Updating...</> : <><Save /> Update Price</>}
//                     </button>
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Funds Modal */}
//       {fundsUser && (
//         <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
//           <div className="bg-[#f0EFEB] rounded-2xl shadow-2xl w-full max-w-md">
//             <div className="bg-[#0C4550] p-6 rounded-t-2xl border-b border-[#C5F637]/20">
//               <div className="flex justify-between items-center">
//                 <div>
//                   <p className="text-2xl font-bold text-white flex items-center gap-2">
//                     <CreditCard /> Manage Funds
//                   </p>
//                   <p className="text-[#A7A08F] text-sm mt-1">
//                     For: {fundsUser.firstName} {fundsUser.lastName}
//                   </p>
//                 </div>
//                 <button
//                   onClick={() => setFundsUser(null)}
//                   className="text-white/80 hover:text-[#C5F637] p-1.5 rounded-full hover:bg-white/10 transition-colors"
//                 >
//                   <X size={24} />
//                 </button>
//               </div>
//             </div>

//             <form onSubmit={handleFundsSubmit} className="p-6 space-y-6">
//               <div className="flex items-start gap-3 p-4 bg-[#0C4550]/5 border border-[#0C4550]/20 rounded-xl text-[#0C4550] text-sm">
//                 <Info className="mt-0.5 flex-shrink-0" size={16} />
//                 <p>Credit or debit funds from user's wallet. This action will be recorded in transaction history.</p>
//               </div>

//               <div className="grid grid-cols-2 gap-3">
//                 <button
//                   type="button"
//                   onClick={() => setFundsData({ ...fundsData, action: "CREDIT" })}
//                   className={`py-3.5 rounded-xl border-2 font-semibold transition-all flex items-center justify-center gap-2 ${fundsData.action === "CREDIT"
//                     ? "border-emerald-500 bg-emerald-50 text-emerald-700"
//                     : "border-gray-200 bg-white text-gray-600 hover:border-emerald-200"
//                     }`}
//                 >
//                   <ArrowUpRight size={18} />
//                   Credit (+)
//                 </button>
//                 <button
//                   type="button"
//                   onClick={() => setFundsData({ ...fundsData, action: "DEBIT" })}
//                   className={`py-3.5 rounded-xl border-2 font-semibold transition-all flex items-center justify-center gap-2 ${fundsData.action === "DEBIT"
//                     ? "border-red-500 bg-red-50 text-red-700"
//                     : "border-gray-200 bg-white text-gray-600 hover:border-red-200"
//                     }`}
//                 >
//                   <ArrowDownRight size={18} />
//                   Debit (-)
//                 </button>
//               </div>

//               <div className="group">
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Amount</label>
//                 <div className="relative">
//                   <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
//                     <IndianRupee className="text-gray-400" />
//                   </div>
//                   <input
//                     type="number"
//                     step="0.01"
//                     min="0"
//                     placeholder="0.00"
//                     value={fundsData.amount}
//                     onChange={(e) => setFundsData({ ...fundsData, amount: e.target.value })}
//                     className="w-full pl-10 pr-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
//                     required
//                   />
//                 </div>
//               </div>

//               <div className="flex gap-3 pt-2">
//                 <button
//                   type="button"
//                   onClick={() => setFundsUser(null)}
//                   className="flex-1 py-3.5 text-sm font-semibold text-gray-700 bg-white border-2 border-gray-300 rounded-xl hover:bg-gray-50 hover:border-gray-400 transition-all duration-200"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   disabled={fundsLoading}
//                   className={`flex-1 py-3.5 text-sm font-semibold text-white rounded-xl transition-all duration-200 shadow-lg flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed ${fundsData.action === "CREDIT"
//                     ? "bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700"
//                     : "bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700"
//                     }`}
//                 >
//                   {fundsLoading ? <><Loader className="animate-spin" /> Processing...</> : fundsData.action === "CREDIT" ? <><ArrowUpRight /> Credit Funds</> : <><ArrowDownRight /> Debit Funds</>}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* History Modal */}
//       {historyUser && (
//         <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
//           <div className="bg-[#f0EFEB] rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col">
//             <div className="bg-[#0C4550] p-6 rounded-t-2xl border-b border-[#C5F637]/20">
//               <div className="flex justify-between items-center">
//                 <div>
//                   <p className="text-2xl font-bold text-white flex items-center gap-2">
//                     <History /> Transaction History
//                   </p>
//                   <p className="text-[#A7A08F] text-sm mt-1">
//                     For: {historyUser.firstName} {historyUser.lastName}
//                   </p>
//                 </div>
//                 <button
//                   onClick={() => setHistoryUser(null)}
//                   className="text-white/80 hover:text-[#C5F637] p-1.5 rounded-full hover:bg-white/10 transition-colors"
//                 >
//                   <X size={24} />
//                 </button>
//               </div>

//               <div className="flex flex-wrap gap-2 mt-4 ">
//                 {["ALL", "CREDIT", "DEBIT"].map((filter) => (
//                   <button
//                     key={filter}
//                     onClick={() => setHistoryFilter(filter)}
//                     className={`px-3 py-1.5 rounded-lg text-medium font-semibold transition-all ${historyFilter === filter
//                       ? "bg-[#C5F637] text-[#0C4550]"
//                       : "bg-white/10 text-white hover:bg-white/20"
//                       }`}
//                   >
//                     {filter === "CREDIT" ? "Received" : filter === "DEBIT" ? "Sent" : "All"}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             <div className="p-6 overflow-y-auto flex-1">
//               {historyLoading ? (
//                 <div className="py-10 flex flex-col items-center justify-center text-gray-500">
//                   <Loader className="animate-spin mb-4" size={32} />
//                   <span>Loading transaction history...</span>
//                 </div>
//               ) : transactions.length === 0 ? (
//                 <div className="py-16 flex flex-col items-center justify-center text-gray-400">
//                   <History className="mb-4" size={48} />
//                   <p className="text-lg font-medium text-gray-600">No transactions found</p>
//                 </div>
//               ) : (
//                 <div className="space-y-4">
//                   {(historyFilter === "ALL" || historyFilter === "DEBIT") && (
//                     <div>
//                       {transactions
//                         .filter(t => t.amount < 0)
//                         .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
//                         .map((transaction) => (
//                           <div
//                             key={transaction.id}
//                             className="p-5 mb-4 bg-white border border-red-100 rounded-2xl shadow-sm hover:shadow-md transition-shadow"
//                           >
//                             <div className="flex items-start justify-between">
//                               <div className="flex items-start gap-4 flex-1">
//                                 <div className="p-3 rounded-xl bg-red-50 text-red-600 mt-1">
//                                   <ArrowUpRight size={20} />
//                                 </div>
//                                 <div className="flex-1">
//                                   <div className="flex items-center justify-between mb-3">
//                                     <div>
//                                       <div className="font-bold text-gray-800 text-lg">
//                                         Transfer Sent
//                                       </div>
//                                       <div className="text-sm text-gray-600 mt-1 flex items-center gap-2">
//                                         <span className="px-2.5 py-1 bg-red-50 text-red-700 rounded-full text-xs font-medium">DEBIT</span>
//                                       </div>
//                                     </div>
//                                     <div className="text-right">
//                                       <div className="text-xl font-bold text-red-600">
//                                         -₹{Math.abs(transaction.amount).toFixed(2)}
//                                       </div>
//                                       <div className="text-sm text-gray-500 mt-1">
//                                         Balance: ₹{transaction.balanceAfter?.toFixed(2)}
//                                       </div>
//                                     </div>
//                                   </div>

//                                   <div className="flex flex-wrap items-center gap-4 pt-4 border-t border-gray-100 text-sm text-gray-600">
//                                     <div className="flex items-center gap-2">
//                                       <Clock size={14} className="text-gray-400" />
//                                       <span>{formatDate(transaction.timestamp)}</span>
//                                     </div>
//                                   </div>
//                                   {transaction.description && (
//                                     <div className="mt-3 p-3 bg-gray-50 rounded-lg">
//                                       <div className="text-sm font-medium text-gray-700 mb-1">Note:</div>
//                                       <div className="text-sm text-gray-600">{transaction.description}</div>
//                                     </div>
//                                   )}
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         ))}
//                     </div>
//                   )}

//                   {(historyFilter === "ALL" || historyFilter === "CREDIT") && (
//                     <div>
//                       {transactions
//                         .filter(t => t.amount > 0)
//                         .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
//                         .map((transaction) => (
//                           <div
//                             key={transaction.id}
//                             className="p-5 mb-4 bg-white border border-emerald-100 rounded-2xl shadow-sm hover:shadow-md transition-shadow"
//                           >
//                             <div className="flex items-start justify-between">
//                               <div className="flex items-start gap-4 flex-1">
//                                 <div className="p-3 rounded-xl bg-emerald-50 text-emerald-600 mt-1">
//                                   <ArrowDownRight size={20} />
//                                 </div>
//                                 <div className="flex-1">
//                                   <div className="flex items-center justify-between mb-3">
//                                     <div>
//                                       <div className="font-bold text-gray-800 text-lg">
//                                         Transfer Received
//                                       </div>
//                                       <div className="text-sm text-gray-600 mt-1 flex items-center gap-2">
//                                         <span className="px-2.5 py-1 bg-emerald-50 text-emerald-700 rounded-full text-xs font-medium">CREDIT</span>
//                                         <span>•</span>
//                                         <span>From {transaction.userId?.slice(0, 8)}...</span>
//                                       </div>
//                                     </div>
//                                     <div className="text-right">
//                                       <div className="text-xl font-bold text-emerald-600">
//                                         +₹{transaction.amount.toFixed(2)}
//                                       </div>
//                                       <div className="text-sm text-gray-500 mt-1">
//                                         Balance: ₹{transaction.balanceAfter?.toFixed(2)}
//                                       </div>
//                                     </div>
//                                   </div>

//                                   <div className="flex flex-wrap items-center gap-4 pt-4 border-t border-gray-100 text-sm text-gray-600">
//                                     <div className="flex items-center gap-2">
//                                       <Clock size={14} className="text-gray-400" />
//                                       <span>{formatDate(transaction.timestamp)}</span>
//                                     </div>
//                                     <div className="flex items-center gap-2">
//                                       <span className="text-gray-400">•</span>
//                                       <span>ID:</span>
//                                       <span className="font-mono text-gray-700">{transaction.id?.slice(0, 12)}...</span>
//                                     </div>
//                                   </div>

//                                   {transaction.description && (
//                                     <div className="mt-3 p-3 bg-gray-50 rounded-lg">
//                                       <div className="text-sm font-medium text-gray-700 mb-1">Note:</div>
//                                       <div className="text-sm text-gray-600">{transaction.description}</div>
//                                     </div>
//                                   )}
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         ))}
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>

//             {!historyLoading && transactions.length > 0 && (
//               <div className="border-t border-gray-200 bg-gray-50 p-6 rounded-b-2xl">
//                 <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
//                   <div className="bg-white p-4 rounded-xl border border-emerald-100">
//                     <div className="text-xs text-gray-500 mb-2 uppercase tracking-wider font-semibold">Total Received</div>
//                     <div className="text-xl font-bold text-emerald-600">
//                       +₹{transactions.filter(t => t.amount > 0).reduce((sum, t) => sum + t.amount, 0).toFixed(2)}
//                     </div>
//                   </div>
//                   <div className="bg-white p-4 rounded-xl border border-red-100">
//                     <div className="text-xs text-gray-500 mb-2 uppercase tracking-wider font-semibold">Total Sent</div>
//                     <div className="text-xl font-bold text-red-600">
//                       -₹{transactions.filter(t => t.amount < 0).reduce((sum, t) => sum + Math.abs(t.amount), 0).toFixed(2)}
//                     </div>
//                   </div>
//                   <div className="bg-white p-4 rounded-xl border border-[#0C4550]/20">
//                     <div className="text-xs text-gray-500 mb-2 uppercase tracking-wider font-semibold">Net Change</div>
//                     <div className={`text-xl font-bold ${transactions.reduce((sum, t) => sum + t.amount, 0) >= 0 ? 'text-emerald-600' : 'text-red-600'}`}>
//                       ₹{transactions.reduce((sum, t) => sum + t.amount, 0).toFixed(2)}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}

//             <div className="p-6 border-t border-gray-200 bg-gray-50 rounded-b-2xl">
//               <button
//                 onClick={() => setHistoryUser(null)}
//                 className="w-full py-3.5 text-sm font-semibold text-gray-700 bg-white border-2 border-gray-300 rounded-xl hover:bg-gray-50 hover:border-gray-400 transition-all duration-200"
//               >
//                 Close History
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ViewAccount;





import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import {
  ChevronLeft,
  ChevronRight,
  Edit,
  UserMinus,
  Key,
  X,
  IndianRupee, 
  TrendingUp,
  Clock,
  Search,
  Users,
  Mail,
  Phone,
  CheckCircle,
  AlertCircle,
  BarChart2,
  UserPlus,
  Briefcase,
  Shield,
  Globe,
  Info,
  Loader,
  Save,
  RefreshCw,
  ChevronDown,
  CreditCard,
  History,
  ArrowUpRight,
  ArrowDownRight
} from "lucide-react";
import { API_URL } from "../../Constants";

// --- UI Utility Functions ---

// Account status badge
const getStatusBadge = (status) => {
  const isActive = status?.toLowerCase() === "active";
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-[11px] font-bold tracking-wide ${isActive
        ? "bg-emerald-50 text-emerald-700 border border-emerald-200"
        : "bg-red-50 text-red-700 border border-red-200"
        }`}
    >
      {isActive ? <CheckCircle size={10} /> : <AlertCircle size={10} />}
      {status || "Unknown"}
    </span>
  );
};

// Account type badge
const getTypeBadge = (type) => {
  const styles = {
    SUPER_ADMIN: "bg-purple-50 text-purple-700 border border-purple-200",
    SUPER_SUPER_ADMIN: "bg-indigo-50 text-indigo-700 border border-indigo-200",
    RESELLER: "bg-[#0C4550]/10 text-[#0C4550] border border-[#0C4550]/20", 
    COMPANY: "bg-blue-50 text-blue-700 border border-blue-200",
    ALL: "bg-gray-100 text-gray-700",
  };
  return (
    <span
      className={`inline-flex px-2.5 py-0.5 rounded-full text-[11px] font-bold tracking-wide w-fit ${styles[type] || "bg-gray-100 text-gray-700"
        }`}
    >
      {type?.replace("_", " ") || "N/A"}
    </span>
  );
};

// --- Main Component ---

const ViewAccount = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4;
  const [filterType, setFilterType] = useState("ALL");
  const [userRole, setUserRole] = useState("");

  // Balance States
  const [balances, setBalances] = useState({});
  const [balanceLoading, setBalanceLoading] = useState({});

  // Modals States
  const [editingUser, setEditingUser] = useState(null);
  
  // State to hold the current form values
  const [formData, setFormData] = useState({});
  // State to hold the original values for comparison
  const [originalData, setOriginalData] = useState({});
  
  const [editLoading, setEditLoading] = useState(false);
  const [suspendUser, setSuspendUser] = useState(null);
  const [confirmCode, setConfirmCode] = useState("");
  const [generatedCode, setGeneratedCode] = useState("");
  
  // Explicit Password states
  const [passwordUser, setPasswordUser] = useState(null);
  const [passwordData, setPasswordData] = useState({ password: "", confirmPassword: "" });

  // Transaction Modals States
  const [smsPricingUser, setSmsPricingUser] = useState(null);
  const [fundsUser, setFundsUser] = useState(null);
  const [historyUser, setHistoryUser] = useState(null);

  // SMS Pricing Modal States
  const [smsPriceData, setSmsPriceData] = useState({ current: "", new: "" });
  const [smsPriceLoading, setSmsPriceLoading] = useState(false);
  const [smsUpdateLoading, setSmsUpdateLoading] = useState(false);

  // Funds Modal States
  const [fundsData, setFundsData] = useState({
    amount: "",
    action: "CREDIT" // CREDIT or DEBIT
  });
  const [fundsLoading, setFundsLoading] = useState(false);

  // History Modal States
  const [transactions, setTransactions] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyFilter, setHistoryFilter] = useState("ALL");

  // Active dropdown state
  const [activeDropdown, setActiveDropdown] = useState(null);
  
  // Refs for dropdown positioning
  const buttonRefs = useRef({});

  // Decode logged-in user role
  useEffect(() => {
    try {
      const token = localStorage.getItem("token");
      if (token) {
        const decoded = jwtDecode(token);
        setUserRole(decoded.accountType || decoded.role || "");
      }
    } catch (err) {
      console.error("Error decoding token:", err);
    }
  }, [])

  // Fetch users list
  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/api/v1/users/list`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        
        const usersList = response.data.data || response.data;
        
        const mappedUsers = usersList.map(u => ({
          ...u,
          accountType: u.role || u.accountType,
          accountStatus: u.active !== undefined ? (u.active ? "ACTIVE" : "INACTIVE") : u.accountStatus,
          idValidFrom: u.validFrom || u.idValidFrom,
          idValidTo: u.validTo || u.idValidTo
        }));

        setUsers(mappedUsers);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  // --- Utility Functions ---

  const handleFetchBalance = async (userId) => {
    if (balanceLoading[userId]) return;
    setBalanceLoading((prev) => ({ ...prev, [userId]: true }));

    try {
      const token = localStorage.getItem("token");
      // Correct endpoint: GET /api/v1/wallet/{targetUserId}/balance
      const response = await axios.get(`${API_URL}/api/v1/wallet/${userId}/balance`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // Response shape: ApiResponse<BalanceResponse> → response.data.data.liveBalancePaise
      const balanceData = response.data?.data;
      const liveBalancePaise = balanceData?.liveBalancePaise ?? null;

      // Convert milli-paise → rupees (1 rupee = 100,000 milli-paise)
      const balanceInRupees = typeof liveBalancePaise === "number"
        ? (liveBalancePaise / 100000).toFixed(2)
        : "Error";

      setBalances((prev) => ({ ...prev, [userId]: balanceInRupees }));
    } catch (error) {
      console.error(`Error fetching balance for user ${userId}:`, error);
      setBalances((prev) => ({ ...prev, [userId]: "Error" }));
    } finally {
      setBalanceLoading((prev) => ({ ...prev, [userId]: false }));
    }
  };

  // --- HANDLE EDIT (NEW GET API) ---
  const handleEdit = useCallback(async (user) => {
    setEditLoading(true);
    setEditingUser(user); // Set early so modal opens showing loading spinner
    try {
      const token = localStorage.getItem("token");
      
      // Fetch specific user details via NEW Hierarchy-Aware Endpoint
      const response = await axios.get(`${API_URL}/api/v1/users/${user.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      
      // Unwrap standard ApiResponse
      const userData = response.data.data || response.data;

      // Date formatter for Instant / ISO strings / Arrays
      const formatApiDate = (dateData) => {
        if (!dateData) return "";
        if (Array.isArray(dateData) && dateData.length >= 3) {
            const year = dateData[0];
            const month = String(dateData[1]).padStart(2, "0");
            const day = String(dateData[2]).padStart(2, "0");
            return `${year}-${month}-${day}`;
        }
        if (typeof dateData === 'string') {
            return dateData.split('T')[0];
        }
        return "";
      };

      // Prepare initial object mapping for the form
      const initialData = {
        firstName: userData.firstName || "",
        lastName: userData.lastName || "",
        email: userData.email || "", // Kept for reference (uneditable typically)
        phone: userData.phone || "",
        
        companyName: userData.companyName || "",
        companyType: userData.companyType || "", 
        gstNumber: userData.gstNumber || "",
        panNumber: userData.panNumber || "",
        address: userData.address || "",
        
        validFrom: formatApiDate(userData.validFrom), 
        validTo: formatApiDate(userData.validTo),       
        active: userData.active, // Boolean for Patch request

        // Reference fields (read-only in form)
        role: userData.role || "",
      };

      setFormData(initialData);
      setOriginalData(initialData); // Exact copy to track isolated changes

    } catch (error) {
      console.error("Error fetching specific user details:", error);
      alert("Failed to fetch user details. You may not have permission.");
      setEditingUser(null);
    } finally {
      setEditLoading(false);
    }
  }, []);

  const closeModal = () => {
    setEditingUser(null);
    setFormData({});
    setOriginalData({});
  };

  // --- HANDLE UPDATE (PATCH API - SPECIFIC FIELDS ONLY) --- 
const handleUpdate = async () => { 
  try { 
    const token = localStorage.getItem("token"); 
      
    // Extract ONLY fields that have been modified compared to originalData 
    const updates = {}; 
    const allowedPatchFields = [ 
      "firstName", "lastName", "phone", "address",  
      "companyName", "companyType", "gstNumber", "panNumber",  
      "validFrom", "validTo", "active" 
    ]; 

    allowedPatchFields.forEach((key) => { 
      if (formData[key] !== originalData[key]) { 
        if (key === 'validFrom' || key === 'validTo') {
          // Handle Date Formatting for Java Instant
          if (formData[key] === "") {
            updates[key] = null; // Clear the date if empty
          } else {
            // Append midnight UTC time so the Java backend can parse it as an Instant
            updates[key] = `${formData[key]}T00:00:00Z`; 
          }
        } else {
          // Handle all other fields normally
          updates[key] = formData[key];
        }
      } 
    }); 

    if (Object.keys(updates).length === 0) { 
      alert("No changes detected."); 
      return; 
    } 

    await axios.patch(`${API_URL}/api/v1/users/${editingUser.id}`, updates, { 
      headers: { Authorization: `Bearer ${token}` }, 
    }); 

    alert("User updated successfully!"); 
    closeModal(); 
    window.location.reload(); 
  } catch (error) { 
    console.error("Error updating user:", error); 
    alert("Failed to update user details."); 
  } 
};
  // --- HANDLE PASSWORD CHANGE (EXPLICIT / SEPARATE API) ---
  const handleChangePassword = (user) => {
    setPasswordUser(user);
    setPasswordData({ password: "", confirmPassword: "" });
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if (passwordData.password !== passwordData.confirmPassword) {
      alert("❌ Passwords do not match!");
      return;
    }
    
    try {
      const token = localStorage.getItem("token");
      
      // Changed to match the backend: 
      // PATCH request to /api/v1/users/{userId} with the password payload
      await axios.patch(
        `${API_URL}/api/v1/users/${passwordUser.id}`,
        { 
          password: passwordData.password 
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      alert(`✅ Password changed for ${passwordUser.firstName}`);
      setPasswordUser(null);
    } catch (err) {
      console.error("Error changing password:", err);
      // Enhanced error handling to catch permission errors (like updating oneself)
      const errorMessage = err.response?.data?.message || "Failed to change password.";
      alert(`❌ ${errorMessage}`);
    }
  };

  const handleSuspend = (user) => {
    const code = Math.random().toString(36).substring(2, 7).toUpperCase();
    setGeneratedCode(code);
    setConfirmCode("");
    setSuspendUser(user);
  };

  const confirmSuspend = async () => {
    try {
      const token = localStorage.getItem("token");
      // Using the same PATCH logic as Edit to update 'active' status
      await axios.patch(`${API_URL}/api/v1/users/${suspendUser.id}`, 
        { active: false }, 
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert(`User ${suspendUser.firstName} has been suspended.`);
      setSuspendUser(null);
      window.location.reload(); 
    } catch (error) {
      console.error("Error suspending user:", error);
      alert("Failed to suspend user.");
    }
  };

  // --- SMS Pricing Functions ---
  const fetchSmsPrice = async (user) => {
    if (!user) return;
    setSmsPriceLoading(true);
    try {
      const token = localStorage.getItem("token");
      
      // 1. Fetch the user's current profile to get the existing smsRate
      const response = await axios.get(`${API_URL}/api/v1/users/${user.id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Extract the smsRate from the ApiResponse wrapper (response.data.data)
      const userData = response.data?.data || {};
      
      setSmsPriceData({
        current: userData.smsRate !== null && userData.smsRate !== undefined ? userData.smsRate : 0,
        new: ""
      });
    } catch (error) {
      console.error("Error fetching SMS price:", error);
      alert("Failed to fetch current SMS price.");
      setSmsPriceData(prev => ({ ...prev, current: "Error" }));
    } finally {
      setSmsPriceLoading(false);
    }
  };

  const handleOpenSmsPricing = (user) => {
    setSmsPricingUser(user);
    fetchSmsPrice(user);
    setActiveDropdown(null);
  };

  const handleUpdateSmsPrice = async () => {
    if (!smsPriceData.new) {
      alert("Please enter a new price value.");
      return;
    }
    setSmsUpdateLoading(true);
    try {
      const token = localStorage.getItem("token");
      
      // 2. Use the PATCH API and the correct payload key: 'smsRate'
      await axios.patch(
        `${API_URL}/api/v1/users/${smsPricingUser.id}`,
        { smsRate: parseFloat(smsPriceData.new) },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      alert("SMS Price updated successfully!");
      setSmsPriceData(prev => ({ ...prev, current: prev.new, new: "" }));
      
      // Optional: Update the user list state if you display the rate in the main table
    } catch (error) {
      console.error("Error updating SMS price:", error);
      alert("Failed to update SMS price.");
    } finally {
      setSmsUpdateLoading(false);
    }
  };

  // --- Funds Functions ---
  const handleOpenFunds = (user) => {
    setFundsUser(user);
    setFundsData({
      amount: "",
      action: "CREDIT"
    });
    setActiveDropdown(null);
  };

  const handleFundsSubmit = async (e) => {
    e.preventDefault();
    if (!fundsData.amount || parseFloat(fundsData.amount) <= 0) {
      alert("Please enter a valid amount.");
      return;
    }

    setFundsLoading(true);
    try {
      const token = localStorage.getItem("token");
      // Convert Rupee amount to Paise (1 Rupee = 100 Paise)
      const amountPaise = Math.round(parseFloat(fundsData.amount) * 100);

      if (fundsData.action === "DEBIT") {
        // Integrate Revoke API
        await axios.post(
          `${API_URL}/api/v1/wallet/revoke`,
          {
            targetUserId: fundsUser.id,
            amountPaise: amountPaise
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        alert(`Debited ₹${fundsData.amount} successfully!`);
      } else {
        // Integrate Recharge API
        await axios.post(
          `${API_URL}/api/v1/wallet/recharge`,
          {
            targetUserId: fundsUser.id,
            amountPaise: amountPaise
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        alert(`Credited ₹${fundsData.amount} successfully!`);
      }

      // Clear cached balance for this user to force refresh
      setBalances(prev => {
        const newBalances = { ...prev };
        delete newBalances[fundsUser.id];
        return newBalances;
      });

      setFundsUser(null);
      setFundsData({
        amount: "",
        action: "CREDIT"
      });
    } catch (error) {
      console.error("Error processing transaction:", error);
      alert(error.response?.data?.message || "Failed to process transaction.");
    } finally {
      setFundsLoading(false);
    }
  };

  // --- History Functions ---
  const handleOpenHistory = async (user) => {
    setHistoryUser(user);
    setHistoryLoading(true);
    setActiveDropdown(null);

    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${API_URL}/api/billing/history/${user.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setTransactions(response.data || []);
    } catch (error) {
      console.error("Error fetching transaction history:", error);
      setTransactions([]);
    } finally {
      setHistoryLoading(false);
    }
  };

  const formatDate = (timestamp) => {
    if (Array.isArray(timestamp) && timestamp.length >= 6) {
      const [year, month, day, hour, minute, second] = timestamp;
      const date = new Date(year, month - 1, day, hour, minute, second);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    }

    const date = new Date(timestamp);
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  // Role-based filter options
  const filterOptions = useMemo(() => {
    if (userRole === "SUPER_SUPER_ADMIN")
      return ["ALL", "SUPER_ADMIN", "RESELLER", "COMPANY"];
    if (userRole === "SUPER_ADMIN") return ["ALL", "RESELLER", "COMPANY"];
    if (userRole === "RESELLER") return ["ALL", "COMPANY"];
    return ["ALL"];
  }, [userRole]);

  // Filtering and Searching Logic
  const filteredUsers = useMemo(() => {
    let filteredByType = users;

    if (userRole === "SUPER_ADMIN") {
      filteredByType = filteredByType.filter(
        (user) => user.accountType === "RESELLER" || user.accountType === "COMPANY"
      );
    } else if (userRole === "RESELLER") {
      filteredByType = filteredByType.filter(
        (user) => user.accountType === "COMPANY"
      );
    }

    if (filterType !== "ALL") {
      filteredByType = filteredByType.filter((user) => user.accountType === filterType);
    }

    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    const result = filteredByType.filter((user) =>
      Object.values(user).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(lowerCaseSearchTerm)
      )
    );
    return result;
  }, [users, filterType, searchTerm, userRole]);


  const sortedUsers = [...filteredUsers].sort((a, b) => {
    if (!a.idValidFrom || !b.idValidFrom) return 0;
    const dateA = new Date(a.idValidFrom[0], a.idValidFrom[1] - 1, a.idValidFrom[2]);
    const dateB = new Date(b.idValidFrom[0], b.idValidFrom[1] - 1, b.idValidFrom[2]);

    if (dateB.getTime() !== dateA.getTime()) {
      return dateB - dateA;
    }
    return b.id.localeCompare(a.id);
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedUsers.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage) || 1;

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };
  const prevPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [filterType, searchTerm]);

  const activeCount = filteredUsers.filter(u => u.accountStatus?.toLowerCase() === 'active').length;
  const resellerCount = filteredUsers.filter(u => u.accountType === 'RESELLER').length;
  
  const getDropdownPosition = (userId) => {
    const button = buttonRefs.current[userId];
    if (!button) return { top: 0, left: 0 };
    
    const rect = button.getBoundingClientRect();
    const dropdownHeight = 140; 
    const dropdownWidth = 256; 
    
    let top = rect.top - dropdownHeight - 10; 
    let left = rect.left - (dropdownWidth / 2) + (rect.width / 2); 
    
    if (top < 10) top = 10; 
    if (left < 10) left = 10; 
    if (left + dropdownWidth > window.innerWidth - 10) {
      left = window.innerWidth - dropdownWidth - 10;
    }
    
    return { top, left };
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (activeDropdown && !e.target.closest('.dropdown-container')) {
        setActiveDropdown(null);
      }
    };
    
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [activeDropdown]);

  return (
    <div className="min-h-screen bg-[#f0EFEB] font-sans overflow-auto">
      <div className="max-w-7xl mx-auto p-3 md:p-5">

        {/* Header Card */}
        <div className="bg-[#0C4550] rounded-2xl shadow-2xl mb-5 p-5 md:p-6">
          <div className="flex flex-col md:flex-row md:items-center justify-between">
            <div className="flex items-center gap-4 mb-4 md:mb-0">
              <div className="w-14 h-14 bg-white/10 backdrop-blur-sm rounded-xl flex items-center justify-center border border-[#C5F637]/30">
                <Users className="h-8 w-8 text-white" />
              </div>
              <div>
                <h1 className="text-2xl md:text-3xl font-bold text-white">Account Management Console</h1>
                <p className="text-[#A7A08F] mt-1 font-medium">View and manage all user accounts in the system</p>
              </div>
            </div>

            <div className="flex flex-wrap gap-3">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 min-w-[120px] border border-white/5">
                <div className="flex items-center gap-2 text-white mb-1">
                  <Users className="h-4 w-4 text-[#C5F637]" />
                  <span className="text-sm font-medium text-white">TOTAL</span>
                </div>
                <div className="text-2xl font-bold text-white">{filteredUsers.length}</div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 min-w-[120px] border border-white/5">
                <div className="flex items-center gap-2 text-white mb-1">
                  <CheckCircle className="h-4 w-4 text-[#C5F637]" />
                  <span className="text-sm font-medium text-white">ACTIVE</span>
                </div>
                <div className="text-2xl font-bold text-white">{activeCount}</div>
              </div>

              {(userRole === 'SUPER_ADMIN' || userRole === 'SUPER_SUPER_ADMIN') && (
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 min-w-[120px] border border-white/5">
                  <div className="flex items-center gap-2 text-white mb-1">
                    <Globe className="h-4 w-4 text-[#C5F637]" />
                    <span className="text-sm font-medium text-white">RESELLERS</span>
                  </div>
                  <div className="text-2xl font-bold text-white">{resellerCount}</div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Filters & Search Section */}
        <div className="bg-white rounded-2xl shadow-lg mb-5 p-5  border border-gray-200">
          <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
            <div className="bg-gray-50 p-1 rounded-xl w-full flex gap-3 flex-col  md:flex-row  border border-gray-200 shadow-inner  overflow-x-auto">
              {filterOptions.map((type) => (
                <button
                  key={type}
                  onClick={() => setFilterType(type)}
                  className={`px-4 py-2 rounded-xl  text-sm font-semibold transition-all duration-300 flex items-center gap-2 whitespace-nowrap ${filterType === type
                    ? "bg-[#0C4550] text-[#C5F637] shadow-md border border-[#0C4550]"
                    : "text-gray-600 hover:bg-gray-100"
                    }`}
                >
                  {type === "SUPER_ADMIN" && <Shield size={14} />}
                  {type === "RESELLER" && <Globe size={14} />}
                  {type === "COMPANY" && <Briefcase size={14} />}
                  {type === "ALL" && <Users size={14} />}
                  {type === "ALL" ? "All Accounts" : type.replace("_", " ")}
                </button>
              ))}
            </div>

            <div className="relative w-full md:w-80">
              <input
                type="text"
                placeholder="Search by name, email, company..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-12 pr-4 py-3 rounded-xl border border-gray-300 bg-white text-sm text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-[#126673] outline-none transition-all duration-300 hover:border-[#0C4550]/50 shadow-sm"
              />
              <div className="absolute inset-y-0 left-4 flex items-center pointer-events-none text-[#0C4550]">
                <Search size={20} />
              </div>
              {searchTerm && (
                <button
                  onClick={() => setSearchTerm('')}
                  className="absolute inset-y-0 right-3 flex items-center text-gray-400 hover:text-[#0C4550] transition-colors"
                >
                  <X size={16} />
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Main Content - Table */}
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-200">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  {["User / Company", "Contact Info", "Type", "Status", "Wallet", "Transactions", "Manage"].map((header, i) => (
                    <th
                      key={i}
                      className={`px-4 py-3 text-left text-xs font-bold text-[#0C4550] uppercase tracking-wider ${i === 6 ? 'text-center' : ''}`}
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {loading ? (
                  <tr>
                    <td colSpan={7} className="py-20 text-center">
                      <div className="inline-block animate-spin rounded-full h-10 w-10 border-4 border-gray-200 border-t-[#0C4550]"></div>
                      <p className="mt-3 text-sm text-gray-600">Loading accounts...</p>
                    </td>
                  </tr>
                ) : currentItems.length === 0 ? (
                  <tr>
                    <td colSpan={7} className="py-16 text-center">
                      <div className="flex flex-col items-center justify-center">
                        <Users className="h-16 w-16 text-gray-300 mb-4" />
                        <p className="text-gray-500 text-lg font-medium">No accounts found</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  currentItems.map((user) => {
                    const position = activeDropdown === user.id ? getDropdownPosition(user.id) : { top: 0, left: 0 };
                    
                    return (
                      <tr
                        key={user.id}
                        className="hover:bg-gray-100 transition-colors duration-200 group border-l-2 border-transparent hover:border-[#C5F637]"
                      >
                        {/* User Profile */}
                        <td className="px-4 py-3 whitespace-nowrap">
                          <div className="flex items-center gap-3">
                            <div className="w-9 h-9 rounded-full bg-white border-2 border-[#0C4550] text-[#0C4550] flex items-center justify-center font-bold text-xs shadow-md">
                              {user.firstName?.charAt(0)}{user.lastName?.charAt(0)}
                            </div>
                            <div>
                              <div className="font-bold text-gray-800 text-sm">{user.firstName} {user.lastName}</div>
                              {user.companyName && (
                                <div className="text-xs text-gray-600 font-medium">{user.companyName}</div>
                              )}
                            </div>
                          </div>
                        </td>

                        {/* Contact */}
                        <td className="px-4 py-3 whitespace-nowrap">
                          <div className="flex flex-col gap-0.5">
                            <div className="flex items-center gap-2 text-gray-800">
                              <Mail size={12} className="text-[#A7A08F]" />
                              <span className="text-xs truncate max-w-[180px]">{user.email}</span>
                            </div>
                            {user.phone && (
                              <div className="flex items-center gap-2 text-gray-600">
                                <Phone size={12} className="text-[#A7A08F]" />
                                <span className="text-xs">{user.phone}</span>
                              </div>
                            )}
                          </div>
                        </td>

                        {/* Type */}
                        <td className="px-4 py-3 whitespace-nowrap">
                          <div className="flex flex-col items-start gap-1">
                            {getTypeBadge(user.accountType)}
                          </div>
                        </td>

                        {/* Status */}
                        <td className="px-4 py-3 whitespace-nowrap">
                          <div className="flex flex-col gap-1 items-start">
                            {getStatusBadge(user.accountStatus)}
                            {user.validTo && (
                              <div className="text-[10px] text-gray-500 flex items-center gap-1">
                                <Clock size={10} />
                                {new Date(user.validTo).toLocaleDateString()}
                              </div>
                            )}
                          </div>
                        </td>

                        {/* Wallet */}
                        <td className="px-4 py-3 whitespace-nowrap">
                          <div className="flex items-center">
                            {balances[user.id] !== undefined ? (
                              <div className="flex items-center gap-1 bg-[#0C4550]/5 border border-[#0C4550]/20 px-2.5 py-1.5 rounded-lg">
                                <span className="text-sm font-bold text-[#0C4550] flex items-center">
                                  <IndianRupee className="inline mr-0.5" size={12} />
                                  {balances[user.id] === "Error"
                                    ? <span className="text-red-500 text-xs">Error</span>
                                    : Number(balances[user.id]).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                  }
                                </span>
                              </div>
                            ) : (
                              <button
                                className="text-xs font-semibold text-[#0C4550] hover:text-[#136C7A] flex items-center gap-1 hover:underline disabled:opacity-50 disabled:cursor-wait"
                                onClick={() => handleFetchBalance(user.id)}
                                disabled={balanceLoading[user.id]}
                              >
                                {balanceLoading[user.id] ? (
                                  <Loader size={12} className="animate-spin text-[#C5F637]" />
                                ) : (
                                  <IndianRupee size={12} className="text-gray-800" />
                                )}
                                {balanceLoading[user.id] ? "..." : "Check"}
                              </button>
                            )}
                          </div>
                        </td>

                        {/* Transactions Dropdown */}
                        <td className="px-4 py-3 whitespace-nowrap dropdown-container">
                          <div className="relative">
                            <button
                              ref={(el) => { if (el) buttonRefs.current[user.id] = el; }}
                              onClick={() => setActiveDropdown(activeDropdown === user.id ? null : user.id)}
                              className="flex items-center gap-1.5 bg-[#0C4550] text-white rounded-full px-3 py-1.5 hover:bg-[#0A3A43] transition-all duration-200 shadow-md font-medium text-xs"
                            >
                              <span>Action</span>
                              <ChevronDown size={14} className={`transform transition-transform duration-200 ${activeDropdown === user.id ? 'rotate-180' : ''}`} />
                            </button>

                            {activeDropdown === user.id && (
                              <div 
                                className="fixed z-[9999] dropdown-container"
                                style={{ top: `${position.top}px`, left: `${position.left}px` }}
                              >
                                <div className="w-64 bg-[#EEF2FC] border border-gray-300 rounded-2xl shadow-2xl animate-fadeIn">
                                  <div className="p-4">
                                    <div className="flex justify-between items-center gap-3">
                                      {/* SMS Pricing */}
                                      <button
                                        onClick={() => handleOpenSmsPricing(user)}
                                        className="flex flex-col items-center gap-2 p-3 hover:bg-[#0C4550]/5 transition-all rounded-xl group flex-1"
                                      >
                                        <div className="w-10 h-10 rounded-full bg-[#0C4550]/10 text-[#0C4550] flex items-center justify-center group-hover:bg-[#0C4550] group-hover:text-[#C5F637] transition-all duration-200">
                                          <IndianRupee size={20} />
                                        </div>
                                        <div className="text-center">
                                          <div className="font-semibold text-gray-800 text-xs">Pricing</div>
                                        </div>
                                      </button>
                                      {/* Funds */}
                                      <button
                                        onClick={() => handleOpenFunds(user)}
                                        className="flex flex-col items-center gap-2 p-3 hover:bg-[#0C4550]/5 transition-all rounded-xl group flex-1"
                                      >
                                        <div className="w-10 h-10 rounded-full bg-[#0C4550]/10 text-[#0C4550] flex items-center justify-center group-hover:bg-[#0C4550] group-hover:text-[#C5F637] transition-all duration-200">
                                          <CreditCard size={20} />
                                        </div>
                                        <div className="text-center">
                                          <div className="font-semibold text-gray-800 text-xs">Funds</div>
                                        </div>
                                      </button>
                                      {/* History */}
                                      <button
                                        onClick={() => handleOpenHistory(user)}
                                        className="flex flex-col items-center gap-2 p-3 hover:bg-[#0C4550]/5 transition-all rounded-xl group flex-1"
                                      >
                                        <div className="w-10 h-10 rounded-full bg-[#0C4550]/10 text-[#0C4550] flex items-center justify-center group-hover:bg-[#0C4550] group-hover:text-[#C5F637] transition-all duration-200">
                                          <History size={20} />
                                        </div>
                                        <div className="text-center">
                                          <div className="font-semibold text-gray-800 text-xs"> History</div>
                                        </div>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </td>

                        {/* Actions */}
                        <td className="px-4 py-3 whitespace-nowrap text-right">
                          <div className="flex items-center justify-end gap-1">
                            <button
                              onClick={() => handleEdit(user)}
                              className="p-2 text-[#0C4550] hover:bg-[#0C4550]/5 rounded-xl transition-colors border border-transparent hover:border-[#0C4550]/20"
                              title="Edit Account"
                            >
                              <Edit size={16} />
                            </button>
                            <button
                              onClick={() => handleChangePassword(user)}
                              className="p-2 text-[#0C4550] hover:bg-[#0C4550]/5 rounded-xl transition-colors border border-transparent hover:border-[#0C4550]/20"
                              title="Change Password"
                            >
                              <Key size={16} />
                            </button>
                            <button
                              onClick={() => handleSuspend(user)}
                              className="p-2 text-red-600 hover:bg-red-50 rounded-xl transition-colors border border-transparent hover:border-red-200"
                              title="Suspend Account"
                            >
                              <UserMinus size={16} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between">
            <span className="text-sm text-gray-700 font-medium">
              Showing {indexOfFirstItem + 1} - {Math.min(indexOfLastItem, filteredUsers.length)} of {filteredUsers.length} accounts
            </span>
            <div className="flex items-center gap-3">
              <button
                onClick={prevPage}
                disabled={currentPage === 1}
                className={`p-2.5 rounded-xl border transition-all ${currentPage === 1
                  ? "border-gray-200 text-gray-300 cursor-not-allowed bg-gray-50"
                  : "border-gray-300 text-gray-700 hover:bg-white hover:border-[#0C4550] hover:text-[#0C4550] active:scale-95 shadow-sm"
                  }`}
              >
                <ChevronLeft size={20} />
              </button>
              <span className="text-sm text-gray-800 font-semibold px-3">
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={nextPage}
                disabled={currentPage === totalPages}
                className={`p-2.5 rounded-xl border transition-all ${currentPage === totalPages
                  ? "border-gray-200 text-gray-300 cursor-not-allowed bg-gray-50"
                  : "border-gray-300 text-gray-700 hover:bg-white hover:border-[#0C4550] hover:text-[#0C4550] active:scale-95 shadow-sm"
                  }`}
              >
                <ChevronRight size={20} />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* --- MODALS --- */}

      {/* EDIT MODAL */}
      {editingUser && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4 overflow-y-auto">
          <div className="bg-[#f0EFEB] rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col my-4">
            <div className="bg-[#0C4550] p-6 rounded-t-2xl border-b border-[#C5F637]/20 sticky top-0 z-10">
              <div className="flex justify-between items-center">
                <h3 className="text-xl font-bold text-white">Edit Account Details</h3>
                <button
                  onClick={closeModal}
                  className="text-white/80 hover:text-[#C5F637] p-1.5 rounded-full hover:bg-white/10 transition-colors"
                >
                  <X size={24} />
                </button>
              </div>
            </div>
            
            <div className="p-6 overflow-y-auto flex-1">
              {editLoading ? (
                <div className="text-center py-10">
                  <div className="inline-block animate-spin rounded-full h-8 w-8 border-4 border-gray-200 border-t-[#0C4550]"></div>
                  <p className="mt-3 text-gray-600">Loading user data...</p>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  
                  {/* Personal Information */}
                  <div className="md:col-span-2">
                    <h4 className="text-lg font-bold text-[#0C4550] mb-4 pb-2 border-b border-[#0C4550]/20">Personal Information</h4>
                  </div>
                  
                  {[
                    ["First Name", "firstName", "text"],
                    ["Last Name", "lastName", "text"],
                  ].map(([lbl, key, type]) => (
                    <div key={key} className="group">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">{lbl}</label>
                      <input
                        type={type}
                        value={formData[key] || ""}
                        onChange={(e) => setFormData({ ...formData, [key]: e.target.value })}
                        className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
                      />
                    </div>
                  ))}

                  <div className="group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Email (Read-Only)</label>
                    <input
                      type="email"
                      value={formData.email || ""}
                      readOnly
                      className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-gray-100 text-gray-500 cursor-not-allowed"
                    />
                  </div>

                  <div className="group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Phone</label>
                    <input
                      type="text"
                      value={formData.phone || ""}
                      onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                      className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
                    />
                  </div>

                  {/* Business Information */}
                  <div className="md:col-span-2 mt-2">
                    <h4 className="text-lg font-bold text-[#0C4550] mb-4 pb-2 border-b border-[#0C4550]/20">Business Information</h4>
                  </div>

                  <div className="group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Company Name</label>
                    <input
                      type="text"
                      value={formData.companyName || ""}
                      onChange={(e) => setFormData({ ...formData, companyName: e.target.value })}
                      className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
                    />
                  </div>

                  <div className="group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Company Type</label>
                    <input
                      type="text"
                      value={formData.companyType || ""}
                      onChange={(e) => setFormData({ ...formData, companyType: e.target.value })}
                      className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
                    />
                  </div>

                  <div className="group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">GST Number</label>
                    <input
                      type="text"
                      value={formData.gstNumber || ""}
                      onChange={(e) => setFormData({ ...formData, gstNumber: e.target.value.toUpperCase() })}
                      className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
                    />
                  </div>

                  <div className="group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">PAN Number</label>
                    <input
                      type="text"
                      value={formData.panNumber || ""}
                      onChange={(e) => setFormData({ ...formData, panNumber: e.target.value.toUpperCase() })}
                      className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
                    />
                  </div>

                  <div className="group md:col-span-2">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Address</label>
                    <textarea
                      value={formData.address || ""}
                      onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                      className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
                      rows="2"
                    />
                  </div>

                  {/* Validity & Account Info */}
                  <div className="md:col-span-2 mt-2">
                    <h4 className="text-lg font-bold text-[#0C4550] mb-4 pb-2 border-b border-[#0C4550]/20">Account Configuration & Status</h4>
                  </div>

                  <div className="group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Valid From</label>
                    <input
                      type="date"
                      value={formData.validFrom || ""}
                      onChange={(e) => setFormData({ ...formData, validFrom: e.target.value })}
                      className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
                    />
                  </div>

                  <div className="group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Valid To</label>
                    <input
                      type="date"
                      value={formData.validTo || ""}
                      onChange={(e) => setFormData({ ...formData, validTo: e.target.value })}
                      className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
                    />
                  </div>
                  
                  <div className="group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Role (Read-Only)</label>
                    <input
                      type="text"
                      value={formData.role || ""}
                      readOnly
                      className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-gray-100 text-gray-500 font-bold cursor-not-allowed"
                    />
                  </div>

                  {/* ACTIVE STATUS TOGGLE */}
                  <div className="group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Account Status</label>
                    <select
                      value={formData.active !== undefined ? String(formData.active) : "true"}
                      onChange={(e) => setFormData({ ...formData, active: e.target.value === "true" })}
                      className={`w-full px-4 py-3 rounded-xl border-2 bg-white focus:outline-none focus:ring-2 transition-all duration-200 shadow-sm font-bold ${
                        formData.active 
                          ? "border-emerald-200 text-emerald-700 focus:border-emerald-400 focus:ring-emerald-200" 
                          : "border-red-200 text-red-700 focus:border-red-400 focus:ring-red-200"
                      }`}
                    >
                      <option value="true">Active (Enabled)</option>
                      <option value="false">Inactive (Disabled)</option>
                    </select>
                  </div>

                </div>
              )}
            </div>
            
            {/* Modal Footer */}
            <div className="p-6 border-t border-gray-200 bg-gray-50 rounded-b-2xl flex justify-end gap-3">
              <button
                onClick={closeModal}
                className="px-6 py-3 text-sm font-semibold text-gray-700 bg-white border-2 border-gray-300 rounded-xl hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 shadow-sm"
              >
                Cancel
              </button>
              <button
                onClick={handleUpdate}
                disabled={editLoading}
                className="px-8 py-3 text-sm font-semibold text-[#C5F637] bg-[#0C4550] rounded-xl hover:bg-[#0A3A43] transition-all duration-200 shadow-lg hover:shadow-xl disabled:opacity-50"
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {/* PASSWORD MODAL (EXPLICIT FLOW) */}
      {passwordUser && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
          <div className="bg-[#f0EFEB] rounded-2xl shadow-2xl w-full max-w-md">
            <div className="bg-[#0C4550] p-6 rounded-t-2xl border-b border-[#C5F637]/20">
              <div className="flex justify-between items-center">
                <h3 className="text-xl font-bold text-white">Change Password</h3>
                <button
                  onClick={() => setPasswordUser(null)}
                  className="text-white/80 hover:text-[#C5F637] p-1.5 rounded-full hover:bg-white/10 transition-colors"
                >
                  <X size={24} />
                </button>
              </div>
            </div>
            <form onSubmit={handlePasswordSubmit} className="p-6 space-y-5">
              <div className="flex items-center gap-4 p-4 bg-[#0C4550]/5 rounded-xl border border-[#0C4550]/20">
                <div className="w-12 h-12 rounded-xl bg-[#0C4550] text-[#C5F637] flex items-center justify-center text-lg font-bold">
                  {passwordUser?.firstName?.[0]}{passwordUser?.lastName?.[0]}
                </div>
                <div className="text-sm font-medium text-gray-800">
                  Changing password for <span className="font-bold">{passwordUser?.firstName} {passwordUser?.lastName}</span>
                </div>
              </div>
              <div className="group">
                <input
                  type="password"
                  placeholder="New Password"
                  className="w-full px-4 py-3.5 rounded-xl border-2 border-gray-200 text-sm focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
                  value={passwordData.password}
                  onChange={(e) => setPasswordData({ ...passwordData, password: e.target.value })}
                  required
                />
              </div>
              <div className="group">
                <input
                  type="password"
                  placeholder="Confirm Password"
                  className="w-full px-4 py-3.5 rounded-xl border-2 border-gray-200 text-sm focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
                  value={passwordData.confirmPassword}
                  onChange={(e) => setPasswordData({ ...passwordData, confirmPassword: e.target.value })}
                  required
                />
              </div>
              <button
                type="submit"
                className="w-full py-3.5 text-sm font-semibold text-[#C5F637] bg-[#0C4550] rounded-xl hover:bg-[#0A3A43] transition-all duration-200 shadow-lg hover:shadow-xl"
              >
                Update Password
              </button>
            </form>
          </div>
        </div>
      )}

      {/* SUSPEND MODAL */}
      {suspendUser && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
          <div className="bg-[#f0EFEB] rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden">
            <div className="bg-gradient-to-r from-red-500 to-red-600 p-6 relative">
              <h3 className="font-bold text-white flex items-center gap-2">
                <AlertCircle size={20} /> Suspend Account
              </h3>
              <button
                onClick={() => setSuspendUser(null)}
                className="absolute top-4 right-4 text-white/80 hover:text-white p-1.5 rounded-full hover:bg-white/10 transition-colors"
              >
                <X size={20} />
              </button>
            </div>
            <div className="p-6">
              <div className="flex items-center gap-4 mb-4 p-4 bg-red-50 rounded-xl border border-red-200">
                <div className="w-12 h-12 rounded-xl bg-[#0C4550] text-white flex items-center justify-center text-lg font-bold">
                  {suspendUser?.firstName?.[0]}{suspendUser?.lastName?.[0]}
                </div>
                <div className="text-sm font-medium text-gray-800">
                  Suspending account for <span className="font-bold">{suspendUser?.firstName} {suspendUser?.lastName}</span>
                </div>
              </div>
              <p className="text-sm text-gray-700 mb-4">
                The user will no longer be able to log in. To confirm suspension, please type the code below:
              </p>
              <div className="bg-red-50 text-red-700 text-center font-mono text-2xl font-extrabold py-4 rounded-xl border border-red-200 mb-4 select-none tracking-wider">
                {generatedCode}
              </div>
              <input
                type="text"
                placeholder="Enter confirmation code"
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl text-center font-mono uppercase outline-none focus:border-red-500 focus:ring-2 focus:ring-red-100 transition-all duration-200 shadow-sm"
                value={confirmCode}
                onChange={(e) => setConfirmCode(e.target.value.toUpperCase())}
              />
              <button
                onClick={confirmSuspend}
                disabled={confirmCode !== generatedCode}
                className={`w-full mt-5 py-3.5 rounded-xl text-sm font-semibold text-white transition-all duration-200 shadow-lg ${
                  confirmCode === generatedCode
                    ? "bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700"
                    : "bg-gray-300 cursor-not-allowed"
                }`}
              >
                Confirm Suspend
              </button>
            </div>
          </div>
        </div>
      )}

      {/* SMS Pricing Modal */}
      {smsPricingUser && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
          <div className="bg-[#f0EFEB] rounded-2xl shadow-2xl w-full max-w-md">
            <div className="bg-[#0C4550] p-6 rounded-t-2xl border-b border-[#C5F637]/20">
              <div className="flex justify-between items-center">
                <div>
                  <h3 className="text-xl font-bold text-white flex items-center gap-2">
                    <IndianRupee /> SMS Pricing
                  </h3>
                  <p className="text-[#A7A08F] text-sm mt-1">
                    For: {smsPricingUser.firstName} {smsPricingUser.lastName}
                  </p>
                </div>
                <button
                  onClick={() => setSmsPricingUser(null)}
                  className="text-white/80 hover:text-[#C5F637] p-1.5 rounded-full hover:bg-white/10 transition-colors"
                >
                  <X size={24} />
                </button>
              </div>
            </div>

            <div className="p-6 space-y-6">
              <div className="flex items-start gap-3 p-4 bg-[#0C4550]/5 border border-[#0C4550]/20 rounded-xl text-[#0C4550] text-sm">
                <Info className="mt-0.5 flex-shrink-0" size={16} />
                <p>Update the cost per SMS for this specific user. This will override default system rates.</p>
              </div>

              {smsPriceLoading ? (
                <div className="py-8 flex flex-col items-center justify-center text-gray-500">
                  <Loader className="animate-spin mb-2" size={24} />
                  <span>Fetching current rates...</span>
                </div>
              ) : (
                <>
                  <div className="group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Current SMS Cost</label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                        <IndianRupee className="text-gray-400" />
                      </div>
                      <input
                        type="text"
                        value={smsPriceData.current}
                        readOnly
                        className="w-full pl-10 pr-4 py-3 rounded-xl border-2 border-gray-200 bg-gray-100 text-gray-500 cursor-not-allowed font-medium shadow-inner"
                      />
                    </div>
                  </div>

                  <div className="group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">New SMS Cost</label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                        <IndianRupee className="text-[#0C4550]" />
                      </div>
                      <input
                        type="number"
                        step="0.01"
                        min="0"
                        placeholder="0.00"
                        value={smsPriceData.new}
                        onChange={(e) => setSmsPriceData({ ...smsPriceData, new: e.target.value })}
                        className="w-full pl-10 pr-4 py-3 rounded-xl border-2 border-[#0C4550]/20 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
                      />
                    </div>
                  </div>

                  <div className="flex gap-3 pt-2">
                    <button
                      onClick={() => setSmsPricingUser(null)}
                      className="flex-1 py-3.5 text-sm font-semibold text-gray-700 bg-white border-2 border-gray-300 rounded-xl hover:bg-gray-50 hover:border-gray-400 transition-all duration-200"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleUpdateSmsPrice}
                      disabled={smsUpdateLoading || !smsPriceData.new}
                      className="flex-1 py-3.5 text-sm font-semibold text-[#C5F637] bg-[#0C4550] rounded-xl hover:bg-[#0A3A43] transition-all duration-200 shadow-lg flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
                    >
                      {smsUpdateLoading ? <><Loader className="animate-spin" /> Updating...</> : <><Save /> Update Price</>}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Funds Modal */}
      {fundsUser && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
          <div className="bg-[#f0EFEB] rounded-2xl shadow-2xl w-full max-w-md">
            <div className="bg-[#0C4550] p-6 rounded-t-2xl border-b border-[#C5F637]/20">
              <div className="flex justify-between items-center">
                <div>
                  <p className="text-2xl font-bold text-white flex items-center gap-2">
                    <CreditCard /> Manage Funds
                  </p>
                  <p className="text-[#A7A08F] text-sm mt-1">
                    For: {fundsUser.firstName} {fundsUser.lastName}
                  </p>
                </div>
                <button
                  onClick={() => setFundsUser(null)}
                  className="text-white/80 hover:text-[#C5F637] p-1.5 rounded-full hover:bg-white/10 transition-colors"
                >
                  <X size={24} />
                </button>
              </div>
            </div>

            <form onSubmit={handleFundsSubmit} className="p-6 space-y-6">
              <div className="flex items-start gap-3 p-4 bg-[#0C4550]/5 border border-[#0C4550]/20 rounded-xl text-[#0C4550] text-sm">
                <Info className="mt-0.5 flex-shrink-0" size={16} />
                <p>Credit or debit funds from user's wallet. This action will be recorded in transaction history.</p>
              </div>

              <div className="grid grid-cols-2 gap-3">
                <button
                  type="button"
                  onClick={() => setFundsData({ ...fundsData, action: "CREDIT" })}
                  className={`py-3.5 rounded-xl border-2 font-semibold transition-all flex items-center justify-center gap-2 ${fundsData.action === "CREDIT"
                    ? "border-emerald-500 bg-emerald-50 text-emerald-700"
                    : "border-gray-200 bg-white text-gray-600 hover:border-emerald-200"
                    }`}
                >
                  <ArrowUpRight size={18} />
                  Credit (+)
                </button>
                <button
                  type="button"
                  onClick={() => setFundsData({ ...fundsData, action: "DEBIT" })}
                  className={`py-3.5 rounded-xl border-2 font-semibold transition-all flex items-center justify-center gap-2 ${fundsData.action === "DEBIT"
                    ? "border-red-500 bg-red-50 text-red-700"
                    : "border-gray-200 bg-white text-gray-600 hover:border-red-200"
                    }`}
                >
                  <ArrowDownRight size={18} />
                  Debit (-)
                </button>
              </div>

              <div className="group">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Amount</label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                    <IndianRupee className="text-gray-400" />
                  </div>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    placeholder="0.00"
                    value={fundsData.amount}
                    onChange={(e) => setFundsData({ ...fundsData, amount: e.target.value })}
                    className="w-full pl-10 pr-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-[#C5F637] focus:ring-2 focus:ring-[#C5F637]/20 transition-all duration-200 shadow-sm"
                    required
                  />
                </div>
              </div>

              <div className="flex gap-3 pt-2">
                <button
                  type="button"
                  onClick={() => setFundsUser(null)}
                  className="flex-1 py-3.5 text-sm font-semibold text-gray-700 bg-white border-2 border-gray-300 rounded-xl hover:bg-gray-50 hover:border-gray-400 transition-all duration-200"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={fundsLoading}
                  className={`flex-1 py-3.5 text-sm font-semibold text-white rounded-xl transition-all duration-200 shadow-lg flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed ${fundsData.action === "CREDIT"
                    ? "bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700"
                    : "bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700"
                    }`}
                >
                  {fundsLoading ? <><Loader className="animate-spin" /> Processing...</> : fundsData.action === "CREDIT" ? <><ArrowUpRight /> Credit Funds</> : <><ArrowDownRight /> Debit Funds</>}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* History Modal */}
      {historyUser && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
          <div className="bg-[#f0EFEB] rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col">
            <div className="bg-[#0C4550] p-6 rounded-t-2xl border-b border-[#C5F637]/20">
              <div className="flex justify-between items-center">
                <div>
                  <p className="text-2xl font-bold text-white flex items-center gap-2">
                    <History /> Transaction History
                  </p>
                  <p className="text-[#A7A08F] text-sm mt-1">
                    For: {historyUser.firstName} {historyUser.lastName}
                  </p>
                </div>
                <button
                  onClick={() => setHistoryUser(null)}
                  className="text-white/80 hover:text-[#C5F637] p-1.5 rounded-full hover:bg-white/10 transition-colors"
                >
                  <X size={24} />
                </button>
              </div>

              <div className="flex flex-wrap gap-2 mt-4 ">
                {["ALL", "CREDIT", "DEBIT"].map((filter) => (
                  <button
                    key={filter}
                    onClick={() => setHistoryFilter(filter)}
                    className={`px-3 py-1.5 rounded-lg text-medium font-semibold transition-all ${historyFilter === filter
                      ? "bg-[#C5F637] text-[#0C4550]"
                      : "bg-white/10 text-white hover:bg-white/20"
                      }`}
                  >
                    {filter === "CREDIT" ? "Received" : filter === "DEBIT" ? "Sent" : "All"}
                  </button>
                ))}
              </div>
            </div>

            <div className="p-6 overflow-y-auto flex-1">
              {historyLoading ? (
                <div className="py-10 flex flex-col items-center justify-center text-gray-500">
                  <Loader className="animate-spin mb-4" size={32} />
                  <span>Loading transaction history...</span>
                </div>
              ) : transactions.length === 0 ? (
                <div className="py-16 flex flex-col items-center justify-center text-gray-400">
                  <History className="mb-4" size={48} />
                  <p className="text-lg font-medium text-gray-600">No transactions found</p>
                </div>
              ) : (
                <div className="space-y-4">
                  {(historyFilter === "ALL" || historyFilter === "DEBIT") && (
                    <div>
                      {transactions
                        .filter(t => t.amount < 0)
                        .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
                        .map((transaction) => (
                          <div
                            key={transaction.id}
                            className="p-5 mb-4 bg-white border border-red-100 rounded-2xl shadow-sm hover:shadow-md transition-shadow"
                          >
                            <div className="flex items-start justify-between">
                              <div className="flex items-start gap-4 flex-1">
                                <div className="p-3 rounded-xl bg-red-50 text-red-600 mt-1">
                                  <ArrowUpRight size={20} />
                                </div>
                                <div className="flex-1">
                                  <div className="flex items-center justify-between mb-3">
                                    <div>
                                      <div className="font-bold text-gray-800 text-lg">
                                        Transfer Sent
                                      </div>
                                      <div className="text-sm text-gray-600 mt-1 flex items-center gap-2">
                                        <span className="px-2.5 py-1 bg-red-50 text-red-700 rounded-full text-xs font-medium">DEBIT</span>
                                      </div>
                                    </div>
                                    <div className="text-right">
                                      <div className="text-xl font-bold text-red-600">
                                        -₹{Math.abs(transaction.amount).toFixed(2)}
                                      </div>
                                      <div className="text-sm text-gray-500 mt-1">
                                        Balance: ₹{transaction.balanceAfter?.toFixed(2)}
                                      </div>
                                    </div>
                                  </div>

                                  <div className="flex flex-wrap items-center gap-4 pt-4 border-t border-gray-100 text-sm text-gray-600">
                                    <div className="flex items-center gap-2">
                                      <Clock size={14} className="text-gray-400" />
                                      <span>{formatDate(transaction.timestamp)}</span>
                                    </div>
                                  </div>
                                  {transaction.description && (
                                    <div className="mt-3 p-3 bg-gray-50 rounded-lg">
                                      <div className="text-sm font-medium text-gray-700 mb-1">Note:</div>
                                      <div className="text-sm text-gray-600">{transaction.description}</div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  )}

                  {(historyFilter === "ALL" || historyFilter === "CREDIT") && (
                    <div>
                      {transactions
                        .filter(t => t.amount > 0)
                        .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
                        .map((transaction) => (
                          <div
                            key={transaction.id}
                            className="p-5 mb-4 bg-white border border-emerald-100 rounded-2xl shadow-sm hover:shadow-md transition-shadow"
                          >
                            <div className="flex items-start justify-between">
                              <div className="flex items-start gap-4 flex-1">
                                <div className="p-3 rounded-xl bg-emerald-50 text-emerald-600 mt-1">
                                  <ArrowDownRight size={20} />
                                </div>
                                <div className="flex-1">
                                  <div className="flex items-center justify-between mb-3">
                                    <div>
                                      <div className="font-bold text-gray-800 text-lg">
                                        Transfer Received
                                      </div>
                                      <div className="text-sm text-gray-600 mt-1 flex items-center gap-2">
                                        <span className="px-2.5 py-1 bg-emerald-50 text-emerald-700 rounded-full text-xs font-medium">CREDIT</span>
                                        <span>•</span>
                                        <span>From {transaction.userId?.slice(0, 8)}...</span>
                                      </div>
                                    </div>
                                    <div className="text-right">
                                      <div className="text-xl font-bold text-emerald-600">
                                        +₹{transaction.amount.toFixed(2)}
                                      </div>
                                      <div className="text-sm text-gray-500 mt-1">
                                        Balance: ₹{transaction.balanceAfter?.toFixed(2)}
                                      </div>
                                    </div>
                                  </div>

                                  <div className="flex flex-wrap items-center gap-4 pt-4 border-t border-gray-100 text-sm text-gray-600">
                                    <div className="flex items-center gap-2">
                                      <Clock size={14} className="text-gray-400" />
                                      <span>{formatDate(transaction.timestamp)}</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                      <span className="text-gray-400">•</span>
                                      <span>ID:</span>
                                      <span className="font-mono text-gray-700">{transaction.id?.slice(0, 12)}...</span>
                                    </div>
                                  </div>

                                  {transaction.description && (
                                    <div className="mt-3 p-3 bg-gray-50 rounded-lg">
                                      <div className="text-sm font-medium text-gray-700 mb-1">Note:</div>
                                      <div className="text-sm text-gray-600">{transaction.description}</div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  )}
                </div>
              )}
            </div>

            {!historyLoading && transactions.length > 0 && (
              <div className="border-t border-gray-200 bg-gray-50 p-6 rounded-b-2xl">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                  <div className="bg-white p-4 rounded-xl border border-emerald-100">
                    <div className="text-xs text-gray-500 mb-2 uppercase tracking-wider font-semibold">Total Received</div>
                    <div className="text-xl font-bold text-emerald-600">
                      +₹{transactions.filter(t => t.amount > 0).reduce((sum, t) => sum + t.amount, 0).toFixed(2)}
                    </div>
                  </div>
                  <div className="bg-white p-4 rounded-xl border border-red-100">
                    <div className="text-xs text-gray-500 mb-2 uppercase tracking-wider font-semibold">Total Sent</div>
                    <div className="text-xl font-bold text-red-600">
                      -₹{transactions.filter(t => t.amount < 0).reduce((sum, t) => sum + Math.abs(t.amount), 0).toFixed(2)}
                    </div>
                  </div>
                  <div className="bg-white p-4 rounded-xl border border-[#0C4550]/20">
                    <div className="text-xs text-gray-500 mb-2 uppercase tracking-wider font-semibold">Net Change</div>
                    <div className={`text-xl font-bold ${transactions.reduce((sum, t) => sum + t.amount, 0) >= 0 ? 'text-emerald-600' : 'text-red-600'}`}>
                      ₹{transactions.reduce((sum, t) => sum + t.amount, 0).toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="p-6 border-t border-gray-200 bg-gray-50 rounded-b-2xl">
              <button
                onClick={() => setHistoryUser(null)}
                className="w-full py-3.5 text-sm font-semibold text-gray-700 bg-white border-2 border-gray-300 rounded-xl hover:bg-gray-50 hover:border-gray-400 transition-all duration-200"
              >
                Close History
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewAccount;